import { createModel } from '@rematch/core'
import { RootModel } from '..'
import jwt_decode from 'jwt-decode'
import {
  createFolder,
  deleteFile,
  deleteFolder,
  listFiles,
  fetchStatusCount,
  uploadRetryFiles,
  listFolders,
  updateFile,
  uploadFile,
  updateFolder,
  listTemplates,
  managePrompts,
  addComments,
  listPromptHistory,
  publishPrompt,
  testPrompt,
  listLLMModels,
  listAllLlmModelsForSettings,
  postLlmConfigCreate,
  postLlmConfigUpdate,
  deleteLlmConfigById,
  getPromptDetails,
  listAppTemplates,
  createApp,
  updateApp,
  testAppTool,
  deleteApp,
  getAppDetails,
  getPublishedAppDetails,
  publishApp,
  listAppHistory,
  listAppVersions,
  getBulkTestStatus,
  testAppshareTool,
  listRunHistory,
  //listAppTags,
  getPromptTags,
  listTags,
  getAppShareDetails,
  appShareLinkGeneration,
  appShareLinkValidation,
  bulkrunStatusApp,
  uploadFilesusingLink,
  uploadFilesFromAppShare,
  generateSASurl,
  terminateBulkrun,
  executeBulkrun,
  appApiIntegrate,
  getPromptTemplateDetails,
  listPublishedPrompts,
  listDraftPrompts,
  getAppDetailsTemplate,
  listAppPublished,
  listAppDraft,
  enableDisableUser,
  listTenantUsers,
  updateUserDetails,
  createUser,
  deleteUser,
  getUserDetails,
  getTenantList,
  createTenants,
  getAccessList,
  getWorkspaceAccess,
  getRoleList,
  deleteAccess,
  createRole,
  updateRole,
  deleteRole,
  getTenantDetails,
  listPackages,
  listProducts,
  updateProducts,
  createPackage,
  updatePackages,
  updateTenants,
  deletePackages,
  deleteTenants,
  disableTenant,
  enableTenant,
  listVectorDb,
  listVisionModels,
  listVoiceModels,
  listModels,
  listIntegrations,
  masterTenantIntegrations,
  deleteIntegration,
  updateIntegration,
  createIntegration,
  listAppForPackage,
  listAppGeneral,
  setAsDefault,
  getFeatureSettings,
  updateFetaureSettingsStatus,
  createFeatureIntegrationSettings,
  createGroupFolder,
  getAutoTagList,
  setAsTemplate,
  updateTicketType,
  updateCompanyInfo,
  updatePersona,
  getFeatureAppDetails,
  getPacakageDetails,
  updateFeatureSettings,
  getEndPointUrl,
  getTenantGroups,
  saveTenantGroups,
  getGroupRowDetails,
  deleteGroupRowDetails,
  deleteGroupsFaqPastTickets,
  getIntegrationToolsForTenant,
  getIntegrationsForSelectedTool,
  listEmbeddingModels,
  importPastTickets,
  controlRoomApi,
  getSubscriptionDetails,
  updateTelemetry,
  deleteTicketsFaqPt,
  listTemplateVersion,
  testChatBot,
  testChatBotAdithyaBirla,
  appInsights,
  getBotDetails,
  updateBot,
  testBot,
  listWidgets,
  listWidgetTypes,
  createWidget,
  testWidget,
  getAgentList,
  getAgentVersions,
  getDefaultAgent,
  setAgentDefault,
  publishAgent,
  getInstallationList,
  getMcpTools,
  createAgent,
  createBot,
  deleteAgent,
  getWidgetDetails,
  updateWidget,
  deleteWidget,
  getBotRunHistoryDetails,
  getBotRunHistoryDetailsOfACoversation,
  listAgentConversations,
  getAgentConversationDetail,
  listScheduler,

  generateCode,
  getAutosolveConversations,
  addCommentsApp,
  getBotTestHistory,
  saveFeedBackAutoSolve,
  getAutoSolveMetaData,
  getWidgetHistoryDetails,
  downloadCsvReport,
  exportAutosolve,
  importAutosolve,
  getUserMappedRoles,
  updateAgentApi,
  createScheduler,
  getMasterData,
  cloneAutosolveFeature,
  createAutoSolveFeature,
  getAppId,
  getAgentAssistFilterDetails,
  getBlockLevelHistory,
  pinotQuery,
  naturalLanguageQueryTranslation,
  downloadCsvReportAgentAssist,
  validateChannel,
  deleteScheduler,
  updateScheduler,
  getSchedulerHistory,
  uploadFilesConfluence,
  uploadFilesSharePoint,
  uploadFilesSlack,
  uploadFilesSlackChannels,
  controlRoomDiscoverScreenSaveFilter,
  getControlRoomDiscoverScreenSavedFilterNames,
  getControlRoomDiscoverScreenSavedFilterDetails,
  getControlRoomDiscoverScreenDelete,
  controlRoomDynamicQuery,
  getControlRoomDiscoverScreenGetColumns,
  getControlRoomDiscoverScreenGetColumnValuesForFilter,
  getSupersetCredentials,
  getSupersetLogin,
  getSupersetCsrfToken,
  getSupersetChartAPI,
  getSupersetChartData,
  updateCustomField,
  getAgentDetails,
  getAutoSolveBlockLevelHistory,
  getllmModelDetailsForAutoSolve,
  fileuploadBulkrun,
  autosolverunbatch,
  deleteFilter,
  getwidgetObjectDetails,
  getActiveEnterPriseHubList,
  getExHubHistory,
  updateEnterPriseHub,
  autosolveTestHistory,
  getSupersetChartID,
  getSupersetUrl,
  emailInvite,
  getAutosolveDashboard,
  getHomeDashboardTotal,
  getAgentAssistDashboard,
  getWorkflowDashboard,
  getSupersetCustomDashboardList,
  getControlRoomFilterList,
  validateDeletion,
  getRealTimeAudio,
  getOrganizationSummaryDriverFilter,
  getCxAutosolveFilter,
  getCxAutosolveDownload,
  getCxAgentAssistFilter,
  getCxAgentAssistDownload,
  getCxAgentAssistCardDetails,
  customerInteractionAutosolveHistory,
  getLiveAgentNotifications,
  liveAgentEndCall,
  customerInteractionAgentAssistHistory,
  getCxAutosolveFourCards,
  getCxSeekerCards,
  getCxSeekerHistoryList,
  downloadCxSeekerCsv,
  updateCxSeekerFeedback,
  executePinotQuery,
  getAlertsList,
  getReportsList,
  addNewReports,
  getTrustforteList,
  getAgentsList,
  getColumnValues,
  getAlertDetails,
  createAlert,
  updateAlert,
  deleteAlert,
  deleteReport,
  getLatestPublishedApp,
  getTrustforteMailDocumentData,
  getDatabaseList,
  getDatabaseSchemas,
  getDatabaseTables,
  getDatabaseColumns,
  saveIntegrations,
  updateDatabaseBlock,
  updateScheduleStatus,
  getEvalsRunStatus,
  getEvalDatasets,
  getEvalHistory,
  runEvalAgent,
  runEvalApp,
  createEvalDataset,
  downloadPdfApi,
  getTemplateList,
  fetchTemplateDetails,
  uploadTemplate,
  deleteTemplate,
  updateactiveliveagent,
  removeactiveliveagent,
  exportWorkflow,
  importWorkflow,
} from '../../api/helpers/contents'
import { v4 as uuidv4 } from 'uuid'
import {
  addValueToLocalStorage,
  getValueFromLocalStorage,
  statusChecker,
  getTenantId,
  getAccessLists,
  getCurrentTimeChatBot,
  statusCheckerWithAuth,
} from '../../utils'
import {
  WizrAzurOrchestratorBulkRun,
  WizrAzurOrchestratorBulkRunwithUrl,
  WizrAzurOrchestratorInstance,
} from '../../utils/wizrAzureConnector'
import axios from 'axios'
import { message } from "antd";


type chatMessage = {
  isSent: boolean
  text: string
  liked: boolean
  disliked: boolean
  knowledgeBase: any
  time: any
  attachments?: Array<{
    fileName: string
    fileType: string
    filePath?: string
    timestamp?: string
  }>
}

interface IContentModel {
  contentData: Array<any>
  contentFilesData: Array<any>
  currentFolder: any
  isContentLoading: boolean,
  permissionsLoaded: boolean,
  isLlmConfigMutating: boolean,
  isAutosolverunbatchLoading: boolean,
  isInnerContentLoading: boolean
  templatesData: Array<any>
  promptHistory: Array<any>
  chatMessage: chatMessage[]
  llmModelList: Array<any>
  llmModelListForSettings: Array<any>
  fileuploadBulkrun: any
  autosolverunbatch: any
  promptData: any
  appData: Array<any>
  appDesignerData: any
  currentAppDetails: any
  currentPublishedAppDetails: any
  testStatus: boolean
  queryUrl: any
  appHistory: Array<any>
  appVersions: any
  bulkRunStatus: boolean
  isBulkRunContentLoading: any
  runHistory: Array<any>
  Tags: Array<any>
  appShareLinkGeneration: any
  appShareLinkValidation: any
  bulkRunResultDynamic: any
  clearBulkRunResultDynamic: any
  clearChatMessage: any
  visionModelList: Array<any>
  fileParams: any
  enduserresult: any
  emailInvite: any
  appApiUrl: any
  updatedUrlforCsvUpload: any
  downloadCsvReportAgentAssist: any
  //promptTags:Array<any>
  vectorDB: any
  userList: Array<any>
  userDetails: any
  tenantList: any
  rolesList: any
  accessList: any
  workspaceAccessList: any
  tenantDetails: any
  productList: any
  packageList: any
  permissionValues: any
  viewUser: any
  integrationList: Array<any>
  masterIntegrationList: Array<any>
  featureSettings: any
  autosolveDashboard: any
  agentAssistDashboard: any
  workflowDashboard: any
  homeDashboardTotal: any
  ticketDetail: any
  autoTagData: any
  agentTagData: any
  endpointdata: any
  tenantGroup: any
  loader: any
  pastTicketData: any
  faqData: any
  // pastTicketApps:any
  agentAssistApps: any
  ticketFaqPtDetails: any
  embeddingModelList: any
  cxAutosolveFilter: any
  cxAutosolveDownload: any
  cxAutosolveFourCards: any
  cxAutosolveHistoryData: any,
  cxAgentAssistFilter: any,
  cxAgentAssistDownload: any,
  cxAgentAssistCardDetails: any,
  cxAgentAssistHistoryData: any,
  cxAgentAssistHistorySelected: any,
  singleAgentAssistConversationDetail: any,
  singleConversationData: any,
  topIntents: any
  topIncreasedIntents: any
  topDecreasedIntents: any
  topTotalIntents: any
  ticketsBasedonIntent: any
  intentsGraphData: any
  intentLists: any
  timetoResponse: any
  timetoResolve: any
  ticketEscallation: any
  firstContactResolution: any
  subscriptionDetails: any
  currentModule: any
  commonTags: any
  allIntents: any
  customerHealth: any
  chatBotHistory: any
  controlroomFilter: any
  controlRoomFiltersList: any
  organizationSummaryDriverFilter: any
  appInsights: any
  botDetails: any
  widgetList: any
  widgetTypes: any
  agentList: any
  agentVersions: any
  toolsList: any
  selectedTools: any
  widgetDetails: any
  WidgetObjectDetails: any
  EnterPriseHubList: any
  ExHubHistoryList: any
  AutosolveRunHistory: any
  AutosolveRunHistoryConversations: any
  agentConversationList: any
  agentConversationDetail: any
  SchedulerList: any
  agentAssistFilterDetails: any
  autoSolveConversationDetail: any
  installationList: any
  generateCode: any
  isChatBotHistoryLoader: boolean
  cleanupResponse: any
  learnMore: any
  terminateUrl: any
  terminateBulkrunforAutoSolve: any
  agentDetails: any
  agentVersion: any
  fileURL: any

  autosolveMetaData: any
  widgetHistoryDetails: any

  totalConversationCount: any
  totalUpvoteCount: any
  totalDownvoteCount: any
  agentTotalConversationCount: any
  agentTotalUpvoteCount: any
  agentTotalDownvoteCount: any
  sasToken: any
  isfileLoading: boolean
  userMappedRoles: any
  createScheduler: any
  masterData: any
  autosolveTestHistory: any
  pinotQueryData: any
  naturalLanguageQueryTranslation: any
  schedulerHistory: any,
  isAgentLoading: boolean
  appId: any
  parsedResponse: any
  blockLevelHistory: any
  totalConversationCountAgentAssist: any
  totalUpvoteCountAgentAssist: any
  totalDownvoteCountAgentAssist: any
  totalConversationCountforAutoSolve: any
  totalUpvoteCountforAutoSolve: any
  totalDownvoteCountforAutoSolve: any
  uploadFilesConfluence: any
  uploadFilesSharePoint: any
  uploadFilesSlack: any
  uploadFilesSlackChannels: any
  isPinotQueryLoading: boolean
  isBotLoading: boolean
  downloadLoading: boolean
  customField: any
  autoSolveBlockLevelHistory: any
  confluenceData: any
  realTimeAudio: any
  liveAgentNotifications: any
  // Seeker state properties
  cxSeekerFilter: any
  cxSeekerDownload: any
  cxSeekerCardDetails: any
  cxSeekerHistoryData: any
  isSeekerCardsLoading: boolean
  isSeekerTableLoading: boolean
  isAgentAssistCardsLoading: boolean
  isAgentAssistTableLoading: boolean
  isAppInsightsLoading: boolean
  isListWidgetsLoading: boolean
  isKnowledgeBaseListFolderLoading: boolean
  isPastTicketsListFolderLoading: boolean
  seekerFeedbackUpdate: any
  cxSeekerConversationDetails: any
  cxSeekerPinotQueryResults: any
  isSeekerConversationLoading: boolean
  isSeekerPinotQueryLoading: boolean
  alertsList: any
  reportsList: any
  trustforteList: any
  agentListForApp: any
  TrustforteDocumentData: any
  databaseList: any
  databaseSchemas: any
  databaseTables: any
  databaseColumns: any
  evalDatasets: any
  evalHistory: any
}
interface ITokenDecoded {
  iss: string
}
const intialState: IContentModel = {
  contentData: [],
  contentFilesData: [],
  currentFolder: null,
  isContentLoading: false,
  permissionsLoaded: false,
  isLlmConfigMutating: false,
  isAutosolverunbatchLoading: false,
  isInnerContentLoading: false,
  templatesData: [],
  promptHistory: [],
  chatMessage: [],
  llmModelList: [],
  llmModelListForSettings: [],
  promptData: {},
  appData: [],
  appId: {},
  appDesignerData: {},
  currentAppDetails: {},
  currentPublishedAppDetails: {},
  testStatus: false,
  queryUrl: {},
  appHistory: [],
  appVersions: [],
  bulkRunStatus: false,
  isBulkRunContentLoading: [],
  runHistory: [],
  Tags: [],
  appShareLinkGeneration: null,
  appShareLinkValidation: null,
  bulkRunResultDynamic: {},
  clearBulkRunResultDynamic: {},
  clearChatMessage: [],
  visionModelList: [],
  fileParams: [],
  enduserresult: [],
  appApiUrl: {},
  emailInvite: [],
  updatedUrlforCsvUpload: [],
  uploadFilesConfluence: {},
  uploadFilesSharePoint: {},
  uploadFilesSlack: {},
  uploadFilesSlackChannels: {},
  vectorDB: null,
  userList: [],
  userDetails: {},
  tenantList: [],
  rolesList: [],
  accessList: [],
  workspaceAccessList: [],
  tenantDetails: {},
  productList: [],
  packageList: [],
  viewUser: {},
  permissionValues: [],
  integrationList: [],
  masterIntegrationList: [],
  featureSettings: {},
  autosolveDashboard: {},
  agentAssistDashboard: {},
  workflowDashboard: {},
  homeDashboardTotal: {},
  ticketDetail: {},
  autoTagData: [],
  agentTagData: [],
  endpointdata: null,
  tenantGroup: [],
  loader: false,
  pastTicketData: [],
  faqData: [],
  // pastTicketApps:[],
  agentAssistApps: [],
  ticketFaqPtDetails: [],
  embeddingModelList: [],
  cxAutosolveFilter: [],
  cxAutosolveDownload: [],
  cxAutosolveFourCards: [],
  cxAutosolveHistoryData: [],
  cxAgentAssistFilter: [],
  cxAgentAssistDownload: [],
  cxAgentAssistCardDetails: [],
  cxAgentAssistHistoryData: [],
  cxAgentAssistHistorySelected: [],
  singleAgentAssistConversationDetail: [],
  singleConversationData: null,
  topIntents: [],
  topIncreasedIntents: [],
  topDecreasedIntents: [],
  topTotalIntents: [],
  ticketsBasedonIntent: [],
  intentsGraphData: [],
  intentLists: [],
  timetoResponse: [],
  timetoResolve: [],
  ticketEscallation: [],
  firstContactResolution: [],
  subscriptionDetails: '',
  commonTags: [],
  currentModule: '',
  customerHealth: {},
  allIntents: [],
  chatBotHistory: [],
  controlroomFilter: {},
  controlRoomFiltersList: {},
  organizationSummaryDriverFilter: {},
  appInsights: [],
  botDetails: {},
  widgetList: [],
  widgetTypes: [],
  toolsList: [],
  selectedTools: [],
  agentList: [],
  agentVersions: [],
  widgetDetails: {},
  WidgetObjectDetails: {},
  EnterPriseHubList: {},
  ExHubHistoryList: {},
  totalConversationCountAgentAssist: 0,
  totalUpvoteCountAgentAssist: 0,
  totalDownvoteCountAgentAssist: 0,
  totalConversationCountforAutoSolve: 0,
  totalUpvoteCountforAutoSolve: 0,
  totalDownvoteCountforAutoSolve: 0,
  AutosolveRunHistory: [],
  AutosolveRunHistoryConversations: [],
  agentConversationList: [],
  agentConversationDetail: [],
  SchedulerList: [],
  autoSolveConversationDetail: [],
  installationList: [],
  generateCode: '',
  isChatBotHistoryLoader: false,
  cleanupResponse: "",
  learnMore: {},
  terminateUrl: "",
  terminateBulkrunforAutoSolve: "",
  agentDetails: null,
  agentVersion: [],
  fileURL: '',
  autosolveMetaData: [],
  widgetHistoryDetails: [],
  totalConversationCount: 0,
  totalUpvoteCount: 0,
  totalDownvoteCount: 0,
  agentTotalConversationCount: 0,
  agentTotalUpvoteCount: 0,
  agentTotalDownvoteCount: 0,
  sasToken: '',
  isfileLoading: false,
  userMappedRoles: [],
  createScheduler: [],
  masterData: [],
  autosolveTestHistory: [],
  agentAssistFilterDetails: [],
  isAgentLoading: false,
  parsedResponse: '',
  blockLevelHistory: [],
  pinotQueryData: {},
  naturalLanguageQueryTranslation: {},
  schedulerHistory: [],
  isPinotQueryLoading: false,
  downloadCsvReportAgentAssist: [],
  isBotLoading: false,
  downloadLoading: false,
  customField: [],
  autoSolveBlockLevelHistory: [],
  fileuploadBulkrun: [],
  autosolverunbatch: [],
  confluenceData: [],
  realTimeAudio: [],
  liveAgentNotifications: [],
  // Seeker initial state
  cxSeekerFilter: [],
  cxSeekerDownload: [],
  cxSeekerCardDetails: {},
  cxSeekerHistoryData: [],
  isSeekerCardsLoading: false,
  isSeekerTableLoading: false,
  isAgentAssistCardsLoading: false,
  isAgentAssistTableLoading: false,
  isAppInsightsLoading: false,
  isListWidgetsLoading: false,
  isKnowledgeBaseListFolderLoading: false,
  isPastTicketsListFolderLoading: false,
  seekerFeedbackUpdate: null,
  cxSeekerConversationDetails: null,
  cxSeekerPinotQueryResults: [],
  isSeekerConversationLoading: false,
  isSeekerPinotQueryLoading: false,
  alertsList: [],
  reportsList: [],
  trustforteList: [],
  agentListForApp: [],
  TrustforteDocumentData: null,
  databaseList: [],
  databaseSchemas: [],
  databaseTables: [],
  databaseColumns: [],
  evalDatasets: [],
  evalHistory: []
}

export const contentModel = createModel<RootModel>()({
  state: intialState as IContentModel,
  reducers: {
    updateContentData(state, payload: Array<any>) {
      return {
        ...state,
        contentData: payload,
      }
    },
    updateContentFilesData(state, payload: Array<any>) {
      return {
        ...state,
        contentFilesData: payload,
      }
    },
    updateCurrentFolder(state, payload: any) {
      return {
        ...state,
        currentFolder: payload,
      }
    },
    updateContentLoading(state, payload: any) {
      return {
        ...state,
        isContentLoading: payload,
      }
    },
    updateLlmConfigMutating(state, payload: boolean) {
      return {
        ...state,
        isLlmConfigMutating: payload,
      }
    },
    updateSupersetAuth(state, payload: any) {
      return {
        ...state,
        supersetAuth: payload,
      }
    },
    updateAutosolverunbatchLoading(state, payload: any) {
      return {
        ...state,
        isAutosolverunbatchLoading: payload,
      }
    },
    updateDownloadLoading(state, payload: any) {
      return {
        ...state,
        downloadLoading: payload,
      }
    },
    updatePinotQueryLoading(state, payload: any) {
      return {
        ...state,
        isPinotQueryLoading: payload,
      }
    },
    upateBotContentLoading(state, payload: any) {
      return {
        ...state,
        isBotLoading: payload,
      }
    },
    updateAgentLoading(state, payload: any) {
      return {
        ...state,
        isAgentLoading: payload,
      }
    },
    updatefileLoading(state, payload: any) {
      return {
        ...state,
        isfileLoading: payload,
      }
    },
    updateInnerContentLoading(state, payload: any) {
      return {
        ...state,
        isInnerContentLoading: payload,
      }
    },
    updateTemplateData(state, payload: any) {
      return {
        ...state,
        templatesData: payload,
      }
    },
    updatePromptHistory(state, payload: any) {
      return {
        ...state,
        promptHistory: payload,
      }
    },
    updateChatMessage(state, payload: any) {
      return {
        ...state,
        chatMessage: [...state.chatMessage, payload],
      }
    },
    clearChatMessage(state, payload?: any) {
      return {
        ...state,
        chatMessage: [],
      }
    },
    clearBulkRunStatusDynamic(state, payload?: any) {
      return {
        ...state,
        bulkRunResultDynamic: {},
      }
    },
    updateLLMModelList(state, payload: any) {
      return {
        ...state,
        llmModelList: payload,
      }
    },
    updateLLMModelListForSettings(state, payload: any) {
      return {
        ...state,
        llmModelListForSettings: payload,
      }
    },
    updateFileuploadBulkrun(state, payload: any) {
      return {
        ...state,
        fileuploadBulkrun: payload,
      }
    },
    updateAutosolverunbatch(state, payload: any) {
      return {
        ...state,
        autosolverunbatch: payload,
      }
    },
    updateVectorDb(state, payload: any) {
      return {
        ...state,
        vectorDB: payload,
      }
    },
    updatePromptData(state, payload: any) {
      return {
        ...state,
        promptData: payload,
      }
    },
    updateAppData(state, payload: any) {
      return {
        ...state,
        appData: payload,
      }
    },
    updateAppId(state, payload: any) {
      return {
        ...state,
        appId: payload,
      }
    },
    appDesignerCreationData(state, payload: any) {
      return {
        ...state,
        appDesignerData: payload,
      }
    },

    updateCurrentAppDetails(state, payload: any) {
      return {
        ...state,
        currentAppDetails: payload,
      }
    },
    updateCurrentPublishedAppDetails(state, payload: any) {
      return {
        ...state,
        currentPublishedAppDetails: payload,
      }
    },
    updateTemplateList(state, payload: any) {
      return {
        ...state,
        templateList: payload,
      }
    },
    updateTestStatus(state, payload: any) {
      return {
        ...state,
        testStatus: payload,
      }
    },
    updateQueryUrl(state, payload: any) {
      return {
        ...state,
        queryUrl: payload,
      }
    },
    updateQueryUrlWithRequest(state, payload: any) {
      return {
        ...state,
        queryUrl: {
          ...payload.response,
          exec_type: payload.request?.exec_type
        },
      }
    },
    updateAppHistory(state, payload: any) {
      return {
        ...state,
        appHistory: payload,
      }
    },
    updateAppHistoryPagination(state, payload: any) {
      return {
        ...state,
        appHistory: [...state?.appHistory || [], ...payload]
      }
    },
    updateRunHistoryPagination(state, payload: any) {
      return {
        ...state,
        runHistory: [...state?.runHistory || [], ...payload]
      }
    },

    updateAppVersions(state, payload: any) {
      return {
        ...state,
        appVersions: payload,
      }
    },
    updateBulkRunStatus(state, payload: any) {
      return {
        ...state,
        bulkRunStatus: payload,
      }
    },
    updateBulkRunContent(state, payload: any) {
      return {
        ...state,
        isBulkRunContentLoading: payload,
      }
    },
    updateEvalsRunStatus(state, payload: any) {
      return {
        ...state,
        evalsRunStatus: payload,
      }
    },
    updateEvalDatasets(state, payload: Array<any>) {
      return {
        ...state,
        evalDatasets: payload,
      }
    },
    updateEvalHistory(state, payload: Array<any>) {
      return {
        ...state,
        evalHistory: payload,
      }
    },
    updateRunHistory(state, payload: any) {
      return {
        ...state,
        runHistory: payload,
      }
    },
    updateParsedResponse(state, payload: any) {
      return {
        ...state,
        parsedResponse: payload,
      }
    },
    updateTags(state, payload: any) {
      return {
        ...state,
        Tags: payload,
      }
    },
    updatePromptTags(state, payload: any) {
      return {
        ...state,
        promptTags: payload,
      }
    },
    updateAppSharelinkGeneration(state, payload: any) {
      return {
        ...state,
        appShareLinkGeneration: payload,
      }
    },
    updateAppShareLinkValidation(state, payload: any) {
      return {
        ...state,
        appShareLinkValidation: payload,
      }
    },
    updateBulkRunResultDynamic(state, payload: any) {
      return {
        ...state,
        bulkRunResultDynamic: payload,
      }
    },
    updateVisionModelList(state, payload: any) {
      return {
        ...state,
        visionModelList: payload,
      }
    },

    updateFileParams(state, payload: any) {
      return {
        ...state,
        fileParams: [...state.fileParams, payload],
      }
    },
    updateEnduser(state, payload: any) {
      return {
        ...state,
        enduserresult: payload,
      }
    },
    updateAppApiUrl(state, payload: any) {
      return {
        ...state,
        appApiUrl: payload,
      }
    },
    updatedUrlforCsvUpload(state, payload: any) {
      return {
        ...state,
        updatedUrlforCsvUpload: [...state.updatedUrlforCsvUpload, payload],
      }
    },
    updateUploadFilesConfluence(state, payload: any) {
      return {
        ...state,
        uploadFilesConfluence: payload,
      }
    },
    updateUploadFilesSharePoint(state, payload: any) {
      return {
        ...state,
        uploadFilesSharePoint: payload,
      }
    },
    updateUploadFilesSlack(state, payload: any) {
      return {
        ...state,
        uploadFilesSlack: payload,
      }
    },
    updateUploadFilesSlackChannels(state, payload: any) {
      return {
        ...state,
        uploadFilesSlackChannels: payload,
      }
    },
    updateUserList(state, payload?: any) {
      return {
        ...state,
        userList: payload,
      }
    },
    updateEmailInvite(state, payload: any) {
      return {
        ...state,
        emailInvite: payload,
      }
    },
    updateCurrentuserDetails(state, payload: any) {
      return {
        ...state,
        userDetails: payload,
      }
    },
    updateTenantList(state, payload: any) {
      return {
        ...state,
        tenantList: payload,
      }
    },
    updateRolesList(state, payload: any) {
      return {
        ...state,
        rolesList: payload,
      }
    },
    updateAccessList(state, payload: any) {
      return {
        ...state,
        accessList: payload,
      }
    },
    updateWorkspaceAccessList(state, payload: any) {
      return {
        ...state,
        workspaceAccessList: payload,
      }
    },
    updateTenantDetails(state, payload: any) {
      return {
        ...state,
        tenantDetails: payload,
      }
    },
    updatePermissionValues(state, payload: any) {
      return {
        ...state,
        permissionValues: payload,
      }
    },
    updatePermissionsLoaded(state, payload: boolean) {
      return {
        ...state,
        permissionsLoaded: payload,
      }
    },
    updateProductList(state, payload: any) {
      return {
        ...state,
        productList: payload,
      }
    },
    updatePackageList(state, payload: any) {
      return {
        ...state,
        packageList: payload,
      }
    },
    updateViewUser(state, payload?: any) {
      return {
        ...state,
        viewUser: payload,
      }
    },
    updateIntegrationList(state, payload: any) {
      return {
        ...state,
        integrationList: payload,
      }
    },
    updateMatserIntegrationList(state, payload: any) {
      return {
        ...state,
        masterIntegrationList: payload,
      }
    },
    updateUploadedFileValues(state, payload: any) {
      return {
        ...state,
        fileParams: payload,
      }
    },
    updateFeatureSettings(state, payload: any) {
      return {
        ...state,
        featureSettings: payload,
      }
    },
    updateAutosolveDashboard(state, payload: any) {
      return {
        ...state,
        autosolveDashboard: payload,
      }
    },
    updateAgentAssistDashboard(state, payload: any) {
      return {
        ...state,
        agentAssistDashboard: payload,
      }
    },
    updateWorkflowDashboard(state, payload: any) {
      return {
        ...state,
        workflowDashboard: payload,
      }
    },
    updateHomeDashboardTotal(state, payload: any) {
      return {
        ...state,
        homeDashboardTotal: payload,
      }
    },

    updateTicketDetails(state, payload: any) {
      return {
        ...state,
        ticketDetail: payload,
      }
    },
    updateAutoTagData(state, payload: any) {
      return {
        ...state,
        autoTagData: payload,
      }
    },
    updateAgentTagData(state, payload: any) {
      return {
        ...state,
        agentTagData: payload,
      }
    },

    updateEndpointdata(state, payload: any) {
      return {
        ...state,
        endpointdata: payload,
      }
    },
    updateTenantGroups(state, payload: any) {
      return {
        ...state,
        tenantGroup: payload
      }
    },
    updateLoader(state, payload: any) {
      return {
        ...state,
        loader: payload
      }
    },
    updateFaqData(state, payload: Array<any>) {
      return {
        ...state,
        faqData: payload,
      }
    },
    updateConfluenceData(state, payload: Array<any>) {
      return {
        ...state,
        confluenceData: payload,
      }
    },
    updateRealTimeAudio(state, payload: Array<any>) {
      return {
        ...state,
        realTimeAudio: payload,
      }
    },

    updatePastTicketData(state, payload: Array<any>) {
      return {
        ...state,
        pastTicketData: payload,
      }
    },
    // updatePastTicketApps(state, payload: Array<any>) {
    //   return {
    //     ...state,
    //     pastTicketApps: payload,
    //   }
    // },
    updateAgentAssistData(state, payload: Array<any>) {
      return {
        ...state,
        agentAssistApps: payload,
      }
    },
    updateFaqPtTicketDetails(state, payload: Array<any>) {
      return {
        ...state,
        ticketFaqPtDetails: payload,
      }
    },
    updateEmbeddingModelList(state, payload: Array<any>) {
      return {
        ...state,
        embeddingModelList: payload,
      }
    },
    updateCxAutosolveFilter(state, payload: Array<any>) {
      return {
        ...state,
        cxAutosolveFilter: payload,
      }
    },
    updateCxAgentAssistFilter(state, payload: Array<any>) {
      return {
        ...state,
        cxAgentAssistFilter: payload,
      }
    },
    updatecustomerInteractionAutosolveHistory(state, payload: Array<any>) {
      return {
        ...state,
        cxAutosolveHistoryData: payload,
      }
    },
    updatecustomerInteractionAgentAssistHistory(state, payload: Array<any>) {
      return {
        ...state,
        cxAgentAssistHistoryData: payload,
      }
    },
    updateSingleAgentAssistConversationData(state, payload: Array<any>) {
      return {
        ...state,
        cxAgentAssistHistorySelected: payload,
      }
    },
    updatecustomerInteractionAgentAssistHistorySelected(state, payload: Array<any>) {
      return {
        ...state,
        cxAgentAssistHistorySelected: payload,
      }
    },
    updateSingleConversationData(state, payload: any) {
      return {
        ...state,
        singleConversationData: payload,
      }
    },
    updateLiveAgentNotifications(state, payload: Array<any>) {
      return {
        ...state,
        liveAgentNotifications: payload,
      }
    },
    updateCxAutosolveDownload(state, payload: Array<any>) {
      return {
        ...state,
        cxAutosolveDownload: payload,
      }
    },
    updateCxAgentAssistDownload(state, payload: Array<any>) {
      return {
        ...state,
        cxAgentAssistDownload: payload,
      }
    },
    updateCxAgentAssistCardDetails(state, payload: Array<any>) {
      return {
        ...state,
        cxAgentAssistCardDetails: payload,
      }
    },
    updateCxAutosolveFourCards(state, payload: Array<any>) {
      return {
        ...state,
        cxAutosolveFourCards: payload,
      }
    },
    updateTopIntents(state, payload: Array<any>) {
      return {
        ...state,
        topIntents: payload,
      }
    },
    updateTopIncreasedIntents(state, payload: Array<any>) {
      return {
        ...state,
        topIncreasedIntents: payload,
      }
    },
    updateTopDecreasedIntents(state, payload: Array<any>) {
      return {
        ...state,
        topDecreasedIntents: payload,
      }
    },
    updateTotalIntents(state, payload: Array<any>) {
      return {
        ...state,
        topTotalIntents: payload,
      }
    },
    updateTicketsBasedonIntent(state, payload: Array<any>) {
      return {
        ...state,
        ticketsBasedonIntent: payload,
      }
    },
    updateIntentsGraphData(state, payload: Array<any>) {
      return {
        ...state,
        intentsGraphData: payload,
      }
    },
    updateIntentsList(state, payload: Array<any>) {
      return {
        ...state,
        intentLists: payload,
      }
    },
    updateListAllIntents(state, payload: Array<any>) {
      return {
        ...state,
        allIntents: payload,
      }
    },
    updateTimeResponse(state, payload: Array<any>) {
      return {
        ...state,
        timetoResponse: payload,
      }
    },
    updateTimeResolve(state, payload: Array<any>) {
      return {
        ...state,
        timetoResolve: payload,
      }
    },
    updateAppInsightsList(state, payload: Array<any>) {
      return {
        ...state,
        appInsights: payload,
      }
    },
    updateTicketEscallation(state, payload: Array<any>) {
      return {
        ...state,
        ticketEscallation: payload,
      }
    },
    updateFirstContactResolution(state, payload: Array<any>) {
      return {
        ...state,
        firstContactResolution: payload,
      }
    },
    updateSubscriptionDetails(state, payload: any) {
      return {
        ...state,
        subscriptionDetails: payload,
      }
    },
    updateCurrentModule(state, payload: any) {
      return {
        ...state,
        currentModule: payload,
      }
    },
    updateCommonTags(state, payload: Array<any>) {
      return {
        ...state,
        commonTags: payload,
      }
    },
    updateCustomerHealth(state, payload: Array<any>) {
      return {
        ...state,
        customerHealth: payload,
      }
    },
    updateChatBotHistory(state, payload: Array<any>) {
      return {
        ...state,
        chatBotHistory: payload,
      }
    },
    clearChatBotHistory(state, payload?: any) {
      return {
        ...state,
        chatBotHistory: [],
      }
    },
    updateChatMessageState(state, payload: any) {
      return {
        ...state,
        chatMessage: payload,
      }
    },
    updateControlroomFilerValues(state, payload: any) {
      return {
        ...state,
        controlroomFilter: payload
      }
    },
    controlroomFiltersList(state, payload: any) {
      return {
        ...state,
        controlRoomFiltersList: payload
      }
    },
    updateOrganizationSummaryDriverFilter(state, payload: any) {
      return {
        ...state,
        organizationSummaryDriverFilter: payload
      }
    },
    updateBotDetails(state, payload: any) {
      return {
        ...state,
        botDetails: payload
      }
    },
    updateWidgetObjectDetails(state, payload: any) {
      return {
        ...state,
        WidgetObjectDetails: payload
      }
    },
    updateEnterPriseHubActiveList(state, payload: any) {
      return {
        ...state,
        EnterPriseHubList: payload
      }
    },
    updateExHubHistoryList(state, payload: any) {
      return {
        ...state,
        ExHubHistoryList: payload
      }
    },
    updateTrustforteList(state, payload: any) {
      return {
        ...state,
        trustforteList: payload
      }
    },
    updateTrustforteMailDocumentData(state, payload: any) {
      return {
        ...state,
        TrustforteDocumentData: payload
      }
    },
    clearChatDetails(state, payload?: any) {
      return {
        ...state,
        botDetails: [],
      }
    },
    updateWidgetList(state, payload: any) {
      return {
        ...state,
        widgetList: payload
      }
    },
    updateWidgetTypes(state, payload: any) {
      return {
        ...state,
        widgetTypes: payload
      }
    },
    updateWidgetDetails(state, payload: any) {
      return {
        ...state,
        widgetDetails: payload
      }
    },
    updategetWidgetHistoryDetails(state, payload: any) {
      return {
        ...state,
        widgetHistoryDetails: payload
      }
    },
    updateAutosolveRunHistoryDetails(state, payload: any) {
      return {
        ...state,
        AutosolveRunHistory: payload
      }
    },
    updateAutosolveRunHistoryDetailsOfConversation(state, payload: any) {
      return {
        ...state,
        AutosolveRunHistoryConversations: payload
      }
    },
    updateAgentConversationList(state, payload: any) {
      return {
        ...state,
        agentConversationList: payload
      }
    },
    updateAgentConversationDetail(state, payload: any) {
      return {
        ...state,
        agentConversationDetail: payload
      }
    },
    updateAgentAssistFilterDetails(state, payload: any) {
      return {
        ...state,
        agentAssistFilterDetails: payload
      }
    },
    updateAutosolveConversation(state, payload: any) {
      return {
        ...state,
        autoSolveConversationDetail: payload
      }
    },
    updateAutosolveConversationPagination(state, payload: any) {
      return {
        ...state,
        autoSolveConversationDetail: [...state?.autoSolveConversationDetail || [], ...payload]
      }
    },
    updateAgentConversationPagination(state, payload: any) {
      return {
        ...state,
        agentConversationList: [...state?.agentConversationList || [], ...payload]
      }
    },
    updateWidgetChat(state, payload: any) {
      return {
        ...state,
        widgetTypes: payload
      }
    },
    updateAgentList(state, payload: any) {
      return {
        ...state,
        agentList: payload
      }
    },
    updateAgentVersions(state, payload: any) {
      return {
        ...state,
        agentVersions: payload
      }
    },
    clearAgentList(state: any) {
      return {
        ...state,
        agentList: []
      }
    },
    updateSelectedTools(state, payload: any) {
      return {
        ...state,
        selectedTools: payload
      }
    },
    updateListScheduler(state, payload: any) {
      return {
        ...state,
        SchedulerList: payload
      }
    },
    updateSchedulerListPagination(state, payload: any) {
      return {
        ...state,
        SchedulerList: [...state.SchedulerList || [], ...payload]
      }
    },
    updateListInstallation(state, payload: any) {
      return {
        ...state,
        installationList: payload
      }
    },
    updateGenerateCode(state, payload: any) {
      return {
        ...state,
        generateCode: payload
      }
    },
    updateFileUrl(state, payload: any) {
      return {
        ...state,
        fileURL: payload
      }
    },
    updateAutosolveMetaData(state, payload: any) {
      return {
        ...state,
        autosolveMetaData: payload
      }
    },
    updateChatBotHistoryLoader(state, payload: any) {
      return {
        ...state,
        isChatBotHistoryLoader: payload,
      };
    },
    updateCleanupResponse(state, payload: any) {
      return {
        ...state,
        cleanupResponse: payload,
      };
    },
    updateLearnMore(state, payload: any) {
      return {
        ...state,
        learnMore: payload,
      };
    },
    updateTerminateUrl(state, payload: any) {
      return {
        ...state,
        terminateUrl: payload,
      };
    },
    updateTerminateUrlforAutoSolve(state, payload: any) {
      return {
        ...state,
        terminateBulkrunforAutoSolve: payload,
      };
    },
    clearFileParams(state, payload?: any) {
      return {
        ...state,
        fileParams: [],
      }
    },
    updateAgent(state, payload: any) {
      return {
        ...state,
        agentDetails: payload
      }
    },
    updateAutoSolveBlockLevelHistory(state, payload: any) {
      return {
        ...state,
        autoSolveBlockLevelHistory: payload
      }
    },
    clearWidgetDetails(state, payload?: any) {
      return {
        ...state,
        widgetDetails: [],
      }
    },
    clearTotalConversationCount(state, payload?: any) {
      return {
        ...state,
        totalConversationCount: 0
      }
    },
    clearTotalUpvoteCount(state, payload?: any) {
      return {
        ...state,
        totalUpvoteCount: 0
      }
    },
    clearTotalDownvoteCount(state, payload?: any) {
      return {
        ...state,
        totalDownvoteCount: 0
      }
    },
    clearTotalUpvoteCountAgentAssist(state, payload?: any) {
      return {
        ...state,
        agentTotalUpvoteCount: 0
      }
    },
    clearTotalDownvoteCountAgentAssist(state, payload?: any) {
      return {
        ...state,
        agentTotalDownvoteCount: 0
      }
    },
    clearTotalConversationCountAgentAssist(state, payload?: any) {
      return {
        ...state,
        agentTotalConversationCount: 0
      }
    },
    updateTotalConversationCount(state, payload: any) {
      return {
        ...state,
        totalConversationCount: payload
      }
    },
    updateTotalUpvoteCount(state, payload: any) {
      return {
        ...state,
        totalUpvoteCount: payload
      }
    },
    updateTotalDownvoteCount(state, payload: any) {
      return {
        ...state,
        totalDownvoteCount: payload
      }
    },
    updateAgentTotalConversationCount(state, payload: any) {
      return {
        ...state,
        agentTotalConversationCount: payload
      }
    },
    updateAgentTotalUpvoteCount(state, payload: any) {
      return {
        ...state,
        agentTotalUpvoteCount: payload
      }
    },
    updateAgentTotalDownvoteCount(state, payload: any) {
      return {
        ...state,
        agentTotalDownvoteCount: payload
      }
    },
    updateSasToken(state, payload: any) {
      return {
        ...state,
        sasToken: payload
      }
    },
    updateUserMappedRoles(state, payload: any) {
      return {
        ...state,
        userMappedRoles: payload
      }
    },
    updatecreateScheduler(state, payload: any) {
      return {
        ...state,
        createScheduler: payload
      }
    },

    updateBlockLevelHistory(state, payload: any) {
      return {
        ...state,
        blockLevelHistory: payload
      }
    },
    updateMasterData(state, payload: any) {
      return {
        ...state,
        masterData: payload
      }
    },
    updateAutosolveTestHistory(state, payload: any) {
      return {
        ...state,
        autosolveTestHistory: payload
      }
    },
    updatePinotQueryData(state, payload: any) {
      return {
        ...state,
        pinotQueryData: payload
      }
    },
    updateNaturalLanguageQueryTranslation(state, payload: any) {
      return {
        ...state,
        naturalLanguageQueryTranslation: payload
      }
    },
    updateSchedulerHistory: (state: any, payload: any) => ({
      ...state,
      schedulerHistory: payload
    }),
    updateSchedulerHistoryPagination: (state: any, payload: any) => ({
      ...state,
      schedulerHistory: [...state.schedulerHistory, ...payload]
    }),

    updateControlRoomDiscoverScreenSavedFilterNames(state, payload: any) {
      return {
        ...state,
        controlRoomDiscoverScreenSavedFilterNames: payload
      }
    },
    updateControlRoomDiscoverScreenSavedFilterDetails(state, payload: any) {
      return {
        ...state,
        controlRoomDiscoverScreenSavedFilterDetails: payload
      }
    },
    //     updateControlRoomDiscoverScreenSavedDelete(state, payload: any) {
    //   return {
    //     ...state,
    //     controlRoomDiscoverScreenSavedDelete: payload
    //   }
    // },
    updateCustomField(state, payload: any) {
      return {
        ...state,
        customField: payload
      }
    },
    // Seeker reducers
    updateCxSeekerFilter(state, payload: Array<any>) {
      return {
        ...state,
        cxSeekerFilter: payload,
      }
    },
    updateCxSeekerDownload(state, payload: Array<any>) {
      return {
        ...state,
        cxSeekerDownload: payload,
      }
    },
    updateCxSeekerCardDetails(state, payload: any) {
      return {
        ...state,
        cxSeekerCardDetails: payload,
      }
    },
    updateTemplateDetails(state, payload: any) {
      return {
        ...state,
        templateDetails: payload,
      }
    },
    updateCxSeekerHistoryData(state, payload: Array<any>) {
      return {
        ...state,
        cxSeekerHistoryData: payload,
      }
    },
    updateIsSeekerCardsLoading(state, payload: boolean) {
      return {
        ...state,
        isSeekerCardsLoading: payload,
      }
    },
    updateIsSeekerTableLoading(state, payload: boolean) {
      return {
        ...state,
        isSeekerTableLoading: payload,
      }
    },
    updateIsAgentAssistCardsLoading(state, payload: boolean) {
      return {
        ...state,
        isAgentAssistCardsLoading: payload,
      }
    },
    updateIsListWidgetsLoading(state, payload: boolean) {
      return {
        ...state,
        isListWidgetsLoading: payload,
      }
    },
    updateIsAgentAssistTableLoading(state, payload: boolean) {
      return {
        ...state,
        isAgentAssistTableLoading: payload,
      }
    },
    updateIsAppInsightsLoading(state, payload: boolean) {
      return {
        ...state,
        isAppInsightsLoading: payload,
      }
    },
    updateIsKnowledgeBaseListFolderLoading(state, payload: boolean) {
      return {
        ...state,
        isKnowledgeBaseListFolderLoading: payload,
      }
    },
    updateIsPastTicketsListFolderLoading(state, payload: boolean) {
      return {
        ...state,
        isPastTicketsListFolderLoading: payload,
      }
    },
    updateSeekerFeedbackUpdate(state, payload: any) {
      return {
        ...state,
        seekerFeedbackUpdate: payload,
      }
    },
    updateCxSeekerConversationDetails(state, payload: any) {
      return {
        ...state,
        cxSeekerConversationDetails: payload,
      }
    },
    updateCxSeekerPinotQueryResults(state, payload: any) {
      return {
        ...state,
        cxSeekerPinotQueryResults: payload,
      }
    },
    updateIsSeekerConversationLoading(state, payload: boolean) {
      return {
        ...state,
        isSeekerConversationLoading: payload,
      }
    },
    updateIsSeekerPinotQueryLoading(state, payload: boolean) {
      return {
        ...state,
        isSeekerPinotQueryLoading: payload,
      }
    },
    updateAlertsList(state, payload: any) {
      return {
        ...state,
        alertsList: payload,
      }
    },
    updateReportsList(state, payload: any) {
      return {
        ...state,
        reportsList: payload,
      }
    },
    getAgentsListsForApp(state, payload: any) {
      return {
        ...state,
        agentListForApp: payload
      }
    },
    updateDatabaseList(state, payload: any) {
      return {
        ...state,
        databaseList: payload,
      }
    },
    updateDatabaseSchemas(state, payload: any) {
      return {
        ...state,
        databaseSchemas: payload,
      }
    },
    updateDatabaseTables(state, payload: any) {
      return {
        ...state,
        databaseTables: payload,
      }
    },
    updateDatabaseColumns(state, payload: any) {
      return {
        ...state,
        databaseColumns: payload,
      }
    },
  },

  effects: (dispatch: any) => ({
    createFolderEffect: async ({ currentFolderName, currentFolderDescription, currentembeddingModel, currentVectorDatabase }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const payload = {
          folder_id: uuidv4(),
          folder_name: currentFolderName,
          folder_description: currentFolderDescription ? currentFolderDescription : '',
          embedding_model_id: currentembeddingModel,
          vector_config_id: currentVectorDatabase,
          created_at: Date.now(),
          type: 'knowledge_base',
        }
        await createFolder(payload)
        dispatch.contentModel.listFoldersEffect('knowledge_base')
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Folder Added successfully.',
          type: 'success',
        })
      } catch (error: any) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Folder creation failed. Please check the details you provided.',
          type: 'error',
        })
      }
    },
    listFoldersEffect: async (type) => {
      try {
        //dispatch.contentModel.updateContentLoading(true)
        // Set loading state based on type
        if (type === 'knowledge_base') {
          dispatch.contentModel.updateIsKnowledgeBaseListFolderLoading(true)
        } else if (type === 'past_tickets') {
          dispatch.contentModel.updateIsPastTicketsListFolderLoading(true)
        }

        const response = await listFolders(type)
        switch (type) {
          case 'knowledge_base':
            dispatch.contentModel.updateContentData(response?.data?.data)
            dispatch.contentModel.updateIsKnowledgeBaseListFolderLoading(false)
            break
          case 'past_tickets':
            dispatch.contentModel.updatePastTicketData(response?.data?.data)
            dispatch.contentModel.updateIsPastTicketsListFolderLoading(false)
            break
          case 'faq':
            dispatch.contentModel.updateFaqData(response?.data?.data)
            break
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        // Reset loading state on error
        if (type === 'knowledge_base') {
          dispatch.contentModel.updateIsKnowledgeBaseListFolderLoading(false)
        } else if (type === 'past_tickets') {
          dispatch.contentModel.updateIsPastTicketsListFolderLoading(false)
        }
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Oops. Something went wrong.',
          type: 'error',
        })
      }
    },
    listTempFoldersEffect: async (type) => {
      try {
        //dispatch.contentModel.updateContentLoading(true)
        const response = await listFolders(type)
        const responsedata: any = response?.data?.data
        switch (type) {
          case 'knowledge_base':
            dispatch.contentModel.updateContentData(response?.data?.data)
            break
          case 'past_tickets':
            dispatch.contentModel.updatePastTicketData([...responsedata])
            break
          case 'faq':
            dispatch.contentModel.updateFaqData([...responsedata])
            break
          case 'confluence':
            dispatch.contentModel.updateConfluenceData([...responsedata])
            break
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Oops. Something went wrong.',
          type: 'error',
        })
      }
    },
    deleteFolderEffect: async ({ folderId, type }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        await deleteFolder(folderId)
        dispatch.contentModel.listFoldersEffect(type)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Folder Deleted successfully.',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Folder Deleting Failed.',
          type: 'error',
        })
      }
    },
    updateFolderEffect: async ({ payload, type }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateCurrentFolder(payload)
        await updateFolder({
          folder_id: payload?.folder_id,
          folder_name: payload?.folder_name,
          folder_description: payload?.folder_description,
          updated_at: Date.now(),
          // embedding_model_id: payload?.embedding_model_id

        })
        dispatch.contentModel.listFoldersEffect(type)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Folder Updated successfully.',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Folder Updation Failed',
          type: 'error',
        })
      }
    },
    listFilesEffect: async (folderId) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateContentFilesData([])
        const jwtDetails: any = jwt_decode(localStorage.getItem('id_token') || '')
        const response = await listFiles(folderId)
        const fileListsData = response?.data?.data
        const filesToUpload = getValueFromLocalStorage('filesToUpload')?.[folderId] || {}
        const UrlToUpload = getValueFromLocalStorage('UrlToUpload')?.[folderId] || {}
        const fileUploadDataLocal = { ...filesToUpload, ...UrlToUpload }
        if (fileUploadDataLocal) {
          fileListsData?.forEach((fileData: any) => {
            if (fileUploadDataLocal[fileData?.file_name]) {
              delete fileUploadDataLocal[fileData.file_name]
            }
          })

          const localFileListData = Object.keys(fileUploadDataLocal).map((fileMap: any) => ({
            file_id: 'cbd95851-b468-4588-a8af-78fe6a1cab4e',
            file_name: fileMap,
            file_type: null,
            tags: [],
            created_at: Date.now(),
            updated_at: Date.now(),
            content_type: 'file',
            upload_status: 'inprogress',
            user_name: jwtDetails?.name,
          }))
          dispatch.contentModel.updateContentFilesData([...localFileListData, ...fileListsData])
        } else {
          dispatch.contentModel.updateContentFilesData(response?.data?.data)
        }
        //addValueToLocalStorage('filesToUpload', fileUploadDataLocal)

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Oops. Something went wrong.',
          type: 'error',
        })
      }
    },
    updateFileEffect: async ({ file_id, file_name, file_tags }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const payload = {
          file_id: file_id,
          file_name: file_name,
          tags: file_tags,
          updated_at: Date.now(),
        }
        await updateFile(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'File Updated successfully.',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Oops. File Updation Failed.',
          type: 'error',
        })
      }
    },
    uploadFile: async (payload) => {
      try {
        const payloadRefresh = {
          file_names: payload?.file_names,
          tags: payload?.tags,
          folder_id: payload?.folder_id,
          content_type: payload?.type,

        }
        const payloadUpload = {
          ...payloadRefresh,
          created_at: Date.now()
        }
        const payloadAPI = payload.action == 'upload' ? payloadUpload : payloadRefresh

        //     dispatch.contentModel.updateContentLoading(true)
        uploadFile(payloadAPI, payload.action).then((resp: any) => {
          dispatch.contentModel.listFilesEffect(payload?.folder_id)
        })

        setTimeout(() => {
          dispatch.contentModel.listFilesEffect(payload?.folder_id)
        }, 3000)
        // //    dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'File Upload Failed',
          type: 'error',

        })
      }
    },
    uploadFilesConfluence: async (payload: any) => {

      try {
        const response = await uploadFilesConfluence(payload)
        dispatch.contentModel.listFilesEffect(payload?.folder_id)
      } catch (error) {

      }
    },
    uploadFilesSharePoint: async (payload: any) => {
      try {
        const response = await uploadFilesSharePoint(payload)
        dispatch.contentModel.listFilesEffect(payload?.folder_id)
      } catch (error) {

      }
    },
    uploadFilesSlack: async (payload: any) => {
      try {
        const response = await uploadFilesSlack(payload)
        dispatch.contentModel.listFilesEffect(payload?.folder_id)
      } catch (error) {

      }
    },
    uploadFilesSlackChannels: async (payload: any) => {
      try {
        const response = await uploadFilesSlackChannels(payload)
        dispatch.contentModel.updateUploadFilesSlackChannels(response?.data?.data)

      } catch (error) {

      }
    },



    deleteFile: async (payload) => {
      const folderId = localStorage.getItem('folderId')
      try {
        dispatch.contentModel.updateContentLoading(true)
        const paylaodFinal = {
          "file_ids": payload
        }
        const response = await axios.delete(
          `${process.env.REACT_APP_API_CONTENT_MANAGEMENT_DELETE_KNOWLEDGE_BASE}`,
          {
            data: paylaodFinal, // Axios uses `data` for the request body in DELETE requests
            headers: {
              'Content-Type': 'application/json',
              'wizr-auth': localStorage.getItem('id_token') || '',
              'wizr-access-key': process.env.REACT_APP_API_AUTHORIZATION_HEADER_APIKEY_VALUE || '',
            },
          }
        );


        // await deleteFile(fileId).then((response) => {
        if (response?.status === 200) {
          localStorage.removeItem('filesToUpload')
          localStorage.removeItem('UrlToUpload')

        }

        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'File Deleted successfully.',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'File Deletion Failed.',
          type: 'error',
        })
      }
    },
    listPromptTemplates: async () => {
      try {
        dispatch.contentModel.updateTemplateData(null)
        dispatch.contentModel.updateContentLoading(true)
        const response = await listTemplates()
        dispatch.contentModel.updateTemplateData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    listPublishedPrompts: async () => {
      try {
        dispatch.contentModel.updateTemplateData(null)
        dispatch.contentModel.updateContentLoading(true)
        const response = await listPublishedPrompts()
        dispatch.contentModel.updateTemplateData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {

        dispatch.contentModel.updateContentLoading(false)
      }
    },
    listDraftPrompts: async () => {
      try {
        dispatch.contentModel.updateTemplateData(null)
        dispatch.contentModel.updateContentLoading(true)
        const response = await listDraftPrompts()
        dispatch.contentModel.updateTemplateData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {

        dispatch.contentModel.updateContentLoading(false)
      }
    },
    managePrompts: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        // const payloadvectordb = {
        //   query: "SELECT * FROM c where c.tenant_id ='WIZR-BASIC-TENANT' and c.active =true",
        //   container: 'system_config_vector_db',
        // }
        // same api is used for both llm and vision models
        // const responseVectorDB = await listVectorDb()
        // const responseVectorDBKey = responseVectorDB?.data?.data[0]?.id

        const managePromptPayload = {
          ...(localStorage.getItem('prompt_id') &&
            localStorage.getItem('action') !== 'copy' && { id: localStorage.getItem('prompt_id') }),
          name: payload?.name,
          tags: payload?.tags ? payload?.tags : [],
          description: payload?.description ? payload?.description : '',
          published:
            localStorage.getItem('action') === 'edit' && payload?.published === true ? true : false,
          //published:payload?.published,
          published_on: null,
          created_on: payload?.created_on ? payload?.created_on : Date.now(),
          updated_on: Date.now(),

          prompt_body: {
            system_message: payload?.systemMessage,
            temperature: payload?.temperature === undefined ? 0.5 : payload?.temperature,
            max_tokens: payload?.max_tokens ? parseInt(payload?.max_tokens) : 1000,
            top_p: payload?.top_p === undefined ? 0.5 : payload?.top_p,
            frequency_penalty: payload?.frequency_penalty ? payload?.frequency_penalty : 0,
            presence_penalty: payload?.presence_penalty ? payload?.presence_penalty : 0,
            zero_shot: payload?.examples?.length > 0 ? false : true,
            examples:
              payload?.zero_shot || payload?.llm_model?.model_type === 'completion'
                ? []
                : payload?.examples
                  ? payload?.examples
                  : [],
            knowledgebase_required: payload?.knowledgebase_required
              ? payload?.knowledgebase_required
              : false,
            stop_sequences: payload?.stop_sequences ? payload?.stop_sequences : [],
            llm_model_id: payload?.llm_model?.id
              ? payload?.llm_model?.id
              : '820b7f6f-9d64-4a8e-b82c-31b64570a2f2',
            llm_type: payload?.llm_model?.type ? payload?.llm_model?.type : 'azureopenai',
            model_type: payload?.llm_model?.model_type
              ? payload?.llm_model?.model_type
              : 'chatcompletion',
            message_params:
              payload?.message_params?.length > 0
                ? payload?.message_params?.map((item: any) => {
                  return {
                    name: item.name,
                    type: item.parameterType,
                    value: item.modalTags || '',
                  }
                })
                : [],
            //vector_db_key: responseVectorDBKey,
            embedding_model_id: payload?.embedding_model_id ? payload?.embedding_model_id : '',
            folder_id_list: payload?.folderList ? payload?.folderList : [],
          },
        }
        const response = await managePrompts(managePromptPayload)

        dispatch.contentModel.updateContentLoading(false)
        if (response?.status === 200) {
          localStorage.setItem('tested', 'false')
          localStorage.setItem('action', 'edit')
          localStorage.setItem('prompt_id', response?.data?.data?.id)

          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Prompt Created successfully.',
            type: 'success',
          })
        }
      } catch (err) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Prompt Creation Failed.',
          type: 'failed',
        })
      }
    },
    managePromptsApp: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        // const payloadvectordb = {
        //   query: "SELECT * FROM c where c.tenant_id ='WIZR-BASIC-TENANT' and c.active =true",
        //   container: 'system_config_vector_db',
        // }
        // same api is used for both llm and vision models
        // const responseVectorDB = await listVectorDb()
        // const responseVectorDBKey = responseVectorDB?.data?.data[0]?.id

        const managePromptPayload = {
          // id:payload?.id,
          name: payload?.name,
          tags: payload?.tags ? payload?.tags : [],
          description: payload?.description ? payload?.description : '',
          published:
            localStorage.getItem('action') === 'edit' && payload?.published === true ? true : false,
          //published:payload?.published,
          published_on: null,
          created_on: payload?.created_on ? payload?.created_on : Date.now(),
          updated_on: Date.now(),

          prompt_body: {
            system_message: payload?.systemMessage,
            temperature: payload?.temperature === undefined ? 0.5 : payload?.temperature,
            max_tokens: payload?.max_tokens ? parseInt(payload?.max_tokens) : 1000,
            top_p: payload?.top_p === undefined ? 0.5 : payload?.top_p,
            frequency_penalty: payload?.frequency_penalty ? payload?.frequency_penalty : 0,
            presence_penalty: payload?.presence_penalty ? payload?.presence_penalty : 0,
            zero_shot: payload?.examples?.length > 0 ? false : true,
            examples:
              payload?.zero_shot || payload?.llm_model?.model_type === 'completion'
                ? []
                : payload?.examples
                  ? payload?.examples
                  : [],
            knowledgebase_required: payload?.knowledgebase_required
              ? payload?.knowledgebase_required
              : false,
            stop_sequences: payload?.stop_sequences ? payload?.stop_sequences : [],
            llm_model_id: payload?.llm_model?.id
              ? payload?.llm_model?.id
              : '820b7f6f-9d64-4a8e-b82c-31b64570a2f2',
            llm_type: payload?.llm_model?.type ? payload?.llm_model?.type : 'azureopenai',
            model_type: payload?.llm_model?.model_type
              ? payload?.llm_model?.model_type
              : 'chatcompletion',
            message_params:
              payload?.message_params?.length > 0
                ? payload?.message_params?.map((item: any) => {
                  return {
                    name: item.name,
                    type: item.parameterType,
                    value: item.modalTags || '',
                  }
                })
                : [],
            //vector_db_key: responseVectorDBKey,
            embedding_model_id: payload?.embedding_model_id ? payload?.embedding_model_id : '',
            folder_id_list: payload?.folderList ? payload?.folderList : [],
            best_of: payload?.best_of ? payload?.best_of : 1,
            post_response_text: payload?.post_response_text ? payload?.post_response_text : '',
            pre_response_text: payload?.pre_response_text ? payload?.pre_response_text : '',
          },
        }
        const response = await managePrompts(managePromptPayload)

        dispatch.contentModel.updateContentLoading(false)
        if (response?.status === 200) {
          localStorage.setItem('tested', 'false')
          localStorage.setItem('action', 'edit')
          localStorage.setItem('prompt_id', response?.data?.data?.id)

          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Prompt Created successfully.',
            type: 'success',
          })
        }
      } catch (err) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Prompt Creation Failed.',
          type: 'failed',
        })
      }
    },

    listPromptHistory: async (promptId: string) => {
      try {
        dispatch.contentModel.updatePromptHistory(null)
        dispatch.contentModel.updateContentLoading(true)
        const response = await listPromptHistory(promptId)
        dispatch.contentModel.updatePromptHistory(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {

        dispatch.contentModel.updateContentLoading(false)
      }
    },
    publishPromptDraft: async (id: string) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const publishPromptPayload = {
          id: id,
          action: 'publish',
          last_updated: new Date().getTime(),
        }
        const response = await publishPrompt(publishPromptPayload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Prompt Published successfully.',
            type: 'success',
          })
        }
        dispatch.contentModel.updateContentLoading(false)
        dispatch.contentModel.listDraftPrompts()
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Prompt Publish Failed.',
          type: 'failed',
        })
      }
    },
    addComments: async (payload: any) => {
      try {
        const test_id = localStorage.getItem('prompt_history_id')
        const pmt_id = localStorage.getItem('prompt_id')
        const feedBackpayload = {
          id: test_id,
          prompt_id: pmt_id,
          feedback: payload.feedback,
          comment: payload.comment,
        }
        const response = await addComments(feedBackpayload)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Comment added successfully.',
          type: 'success',
        })
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Comment Addition Failed',
          type: 'failed',
        })
      }
    },
    addCommentsApp: async (payload: any) => {
      try {

        const response = await addCommentsApp(payload)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Comment added successfully.',
          type: 'success',
        })
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Comment Addition Failed',
          type: 'failed',
        })
      }
    },
    unpublishPromptPublished: async (id: any) => {
      try {
        const publishPromptPayload = {
          id: id,
          action: 'unpublish',
          last_updated: new Date().getTime(),
        }
        const response = await publishPrompt(publishPromptPayload)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Prompt UnPublished successfully.',
          type: 'success',
        })
        dispatch.contentModel.listPublishedPrompts()
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Prompt UnPublish Failed.',
          type: 'failed',
        })
      }
    },
    promptTestChat: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateTestStatus(true)
        const response = await testPrompt(payload)

        dispatch.contentModel.updateQueryUrl(response?.data)
        const statusResponse = await statusChecker(response?.data?.statusQueryGetUri)
        if (statusResponse) {
          if (statusResponse?.error) {
            dispatch.commonModel.updateNotificationState({
              message: 'Failed',
              description: statusResponse?.error,
              type: 'failed',
            })
          } else {
            dispatch.contentModel.updateContentLoading(false)
            dispatch.contentModel.updateTestStatus(false)
            localStorage.setItem('tested', 'true')
            dispatch.contentModel.updateChatMessage({
              isSent: false,
              text: statusResponse?.llm_response?.content,
            })
          }
        }
      } catch (err) {

      }
      dispatch.contentModel.updateTestStatus(false)
      dispatch.contentModel.updateContentLoading(false)
    },
    LLModelList: async () => {
      const tenantId = getTenantId()

      // const payload = {
      //   query: `SELECT c.id,c.llm_type,c.model_type ,c.llm_settings,c.display_name,c.model_name FROM c where (c.tenant_id='${tenantId}' or c.tenant_id ='WIZR-BASIC-TENANT')and c.status = 'active' and (c.model_type ='chatcompletion' or c.model_type = 'completion')`,
      //   container: 'system_config_llm_model',
      // }

      try {
        const response = await listLLMModels()
        if (response?.status === 200) {
          dispatch.contentModel.updateLLMModelList(response?.data?.data)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    LLModelListForSettings: async () => {
      dispatch.contentModel.updateContentLoading(true)
      try {
        const response = await listAllLlmModelsForSettings()
        if (response?.status === 200) {
          dispatch.contentModel.updateLLMModelListForSettings(response?.data?.data)
        }
      } catch (err) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to load LLM configurations',
          type: 'failed',
        })
      } finally {
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    createLlmConfig: async (apiPayload: any) => {
      dispatch.contentModel.updateLlmConfigMutating(true)
      try {
        const response = await postLlmConfigCreate(apiPayload)
        if (response?.data?.data?.success === false) {
          dispatch.commonModel.updateNotificationState({
            message: 'Failed',
            description: response?.data?.data?.error || 'Failed to save LLM configuration',
            type: 'failed',
          })
          return false
        }
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'LLM configuration created successfully',
          type: 'success',
        })
        await dispatch.contentModel.LLModelListForSettings()
        return true
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create LLM configuration',
          type: 'failed',
        })
        return false
      } finally {
        dispatch.contentModel.updateLlmConfigMutating(false)
      }
    },
    updateLlmConfig: async (apiPayload: any) => {
      dispatch.contentModel.updateLlmConfigMutating(true)
      try {
        const response = await postLlmConfigUpdate(apiPayload)
        if (response?.data?.data?.success === false) {
          dispatch.commonModel.updateNotificationState({
            message: 'Failed',
            description: response?.data?.data?.error || 'Failed to update LLM configuration',
            type: 'failed',
          })
          return false
        }
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'LLM configuration updated successfully',
          type: 'success',
        })
        await dispatch.contentModel.LLModelListForSettings()
        return true
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update LLM configuration',
          type: 'failed',
        })
        return false
      } finally {
        dispatch.contentModel.updateLlmConfigMutating(false)
      }
    },
    deleteLlmConfig: async (id: string) => {
      if (!id?.trim()) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Missing configuration id',
          type: 'failed',
        })
        return false
      }
      dispatch.contentModel.updateLlmConfigMutating(true)
      try {
        const response = await deleteLlmConfigById(id.trim())
        if (response?.data?.data?.success === false) {
          dispatch.commonModel.updateNotificationState({
            message: 'Failed',
            description: response?.data?.data?.error || 'Failed to delete LLM configuration',
            type: 'failed',
          })
          return false
        }
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'LLM configuration deleted successfully',
          type: 'success',
        })
        await dispatch.contentModel.LLModelListForSettings()
        return true
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete LLM configuration',
          type: 'failed',
        })
        return false
      } finally {
        dispatch.contentModel.updateLlmConfigMutating(false)
      }
    },
    getModels: async () => {
      try {
        const response = await listModels()
        if (response?.status === 200) {
          dispatch.contentModel.updateLLMModelList(response?.data?.data)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getVectorDb: async () => {
      const tenantId = getTenantId()

      try {
        const responseVectorDB = await listVectorDb()
        const responseVectorDBKey = responseVectorDB?.data?.data
        if (responseVectorDB?.status === 200) {
          dispatch.contentModel.updateVectorDb(responseVectorDBKey)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getPromptDetails: async ({ promptId }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getPromptDetails(promptId)
        dispatch.contentModel.updatePromptData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getPromptTemplateDetails: async ({ promptId }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getPromptTemplateDetails(promptId)
        dispatch.contentModel.updatePromptData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    listAppTemplates: async () => {
      try {
        dispatch.contentModel.updateAppData(null)
        dispatch.contentModel.updateContentLoading(true)
        const payload = { sort_by: 'c.updated_on', order: 'desc' }
        const response = await listAppTemplates(payload)
        dispatch.contentModel.updateAppData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch {
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    listAppPublished: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateAppData(null)
        const payload = { sort_by: 'c.updated_on', order: 'desc' }
        const response = await listAppPublished(payload)
        dispatch.contentModel.updateAppData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Cannot retrieve data at this moment',
          type: 'failed',
        })
      }
    },
    list: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateAppData(null)
        const payload = { sort_by: 'c.updated_on', order: 'desc' }
        const response = await listAppPublished(payload)
        dispatch.contentModel.updateAppData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Cannot retrieve data at this moment',
          type: 'failed',
        })
      }
    },
    getWidgetHistoryDetails: async ({ payload, tool_id }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        // dispatch.contentModel.updateAppData(null)
        // const payload = { sort_by: 'c.updated_on', order: 'desc' }
        const response = await getWidgetHistoryDetails(payload, tool_id)
        dispatch.contentModel.updategetWidgetHistoryDetails(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Cannot retrieve data at this moment',
          type: 'failed',
        })
      }
    },

    listAppDraft: async () => {
      try {
        dispatch.contentModel.updateAppData(null)
        dispatch.contentModel.updateContentLoading(true)
        const payload = { sort_by: 'c.updated_on', order: 'desc' }
        const response = await listAppDraft(payload)
        dispatch.contentModel.updateAppData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Cannot retrieve data at this moment',
          type: 'failed',
        })
      }
    },
    createApp: async (payload: any) => {
      try {
        const tenantId = getTenantId()

        const { action, ...restOfItem } = payload

        const createAppPayload = {
          app_type: 'Tool',
          created_on: Date.now(),
          updated_on: Date.now(),
          // enabled: true,
          type: 'app',
          default: true,
          status: 'active',
          published: false,
          max_past_messages: payload?.memory ? 15 : 0,
          edges: [],
          nodes: [],
          ...restOfItem,
        }

        dispatch.contentModel.updateContentLoading(true)
        const response = await createApp(createAppPayload)
        dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        dispatch.contentModel.appDesignerCreationData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        console.log(err);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Create App',
          type: 'failed',
        })
      }
    },
    updateAppDetails: async (payload: any) => {
      try {
        dispatch.contentModel.updateCurrentAppDetails(payload)
      } catch (err) {
        console.log({ error: err });
      }
    },
    createAppNewtab: async (payload: any) => {
      try {
        const tenantId = getTenantId()

        const { action, ...restOfItem } = payload

        const createAppPayload = {
          app_version: 'N/A',
          app_type: 'Tool',
          created_on: Date.now(),
          updated_on: Date.now(),
          // enabled: true,
          type: 'app',
          default: true,
          status: 'active',
          published: false,
          max_past_messages: payload?.memory ? 15 : 0,
          edges: [],
          nodes: [],
          ...restOfItem,
        }
        dispatch.contentModel.updateContentLoading(true)
        const response = await createApp(createAppPayload)
        const newWindow: any = window.open(
          `/app-designer/tool/${response?.data?.data?.id}/${response?.data?.data?.app_id}/copy`,
          '_blank',
          'noopener,noreferrer',
        )
        newWindow.opener = null
        dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Created App succcessfuly',
          type: 'success',
        })
        dispatch.contentModel.appDesignerCreationData(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Create App',
          type: 'failed',
        })
      }
    },
    updateApp: async (payload: any) => {
      try {
        const tenantId = getTenantId()
        const updateAppPayload = {
          // app_version: 2,
          app_type: 'Tool',
          updated_on: Date.now(),
          // enabled: true,
          default: true,
          status: 'active',
          published: false,
          tenant_id: payload?.tenant_id ? payload?.tenant_id : tenantId,
          max_past_messages: payload?.memory ? 15 : 0,
          edges: [],
          ...payload,
        }

        // dispatch.contentModel.updateContentLoading(true)
        const response = await updateApp(updateAppPayload)
        dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Updated App succcessfuly',
          type: 'success',
        })
        // dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Update App',
          type: 'failed',
        })
      }
    },
    deleteApp: async (appId: string) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await deleteApp(appId)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Deleted App succcessfuly',
          type: 'success',
        })
        const payload = { sort_by: 'c.updated_on', order: 'desc' }

        // dispatch.contentModel.listAppPublished()
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Delete App',
          type: 'failed',
        })
      }
    },
    validateDeletion: async (appId: string) => {
      try {
        const response = await validateDeletion(appId)
        return response
      } catch (error) {
        throw error
      }
    },
    appToolTest: async (payload: any) => {
      try {
        // dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateTestStatus(true)
        const response = await testAppTool(payload)
        dispatch.contentModel.updateQueryUrlWithRequest({
          response: response?.data,
          request: payload
        })
        const statusResponse = await statusChecker(response?.data?.statusQueryGetUri)
        if (statusResponse.runtimeStatus === "Failed" || statusResponse.runtimeStatus === "Terminated") {
          dispatch.commonModel.updateNotificationState({
            message: statusResponse.runtimeStatus,
            description: statusResponse.error,
            type: 'failed',
          })
        } else {
          const parsedResponse = JSON.parse(statusResponse.output)
          if (parsedResponse) {
            if (parsedResponse?.error) {
              dispatch.commonModel.updateNotificationState({
                message: 'Failed',
                description: parsedResponse.error,
                type: 'failed',
              })
            } else {
              dispatch.contentModel.updateTestStatus(false)
              dispatch.contentModel.updateChatMessage({
                isSent: false,
                text: parsedResponse?.content,
                pdf_url: parsedResponse?.pdf_url,
                knowledgeBase: parsedResponse?.docs_metadata
              })
            }
          }
        }
      } catch (err) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Test App',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
      dispatch.contentModel.updateTestStatus(false)
    },
    getAppDetails: async ({ appId }) => {
      try {
        // dispatch.contentModel.updateContentLoading(true)
        const response = await getAppDetails(appId)
        if (response?.error) {

        } else {
          dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
          //dispatch.contentModel.updateContentLoading(false)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getPublishedAppEditDetails: async ({ appId }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getPublishedAppDetails(appId)
        if (response?.error) {

        } else {
          dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
          dispatch.contentModel.updateContentLoading(false)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getAppDetailsTemplate: async ({ appId }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getAppDetailsTemplate(appId)
        if (response?.error) {

        } else {
          dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
          dispatch.contentModel.updateContentLoading(false)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    stopGeneration: async (url: any) => {
      const newText = 'usercancelled'
      dispatch.contentModel.updateTestStatus(false)
      const updatedUrl = url.replace('{text}', newText)
      const response = await fetch(updatedUrl, { method: 'POST' })
    },
    publishApp: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await publishApp(payload)
        dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'App published succcessfuly',
          type: 'success',
        })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Update App',
          type: 'failed',
        })
      }
    },
    setAsDefault: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await setAsDefault(payload)
        // dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Version as the default',
          type: 'success',
        })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to set deafult version',
          type: 'failed',
        })
      }
    },
    listAppHistory: async ({ appId, payload, pagination }) => {
      try {
        if (!pagination) {
          dispatch.contentModel.updateAppHistory(null)
        }
        dispatch.contentModel.updateContentLoading(true)
        const response = await listAppHistory(appId, payload)
        if (pagination) {

          dispatch.contentModel.updateAppHistoryPagination(response?.data?.data)
        }

        else {
          dispatch.contentModel.updateAppHistory(response?.data?.data)
        }
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getAutosolveTestHistory: async ({ botId, payload }: any) => {
      try {
        const response = await autosolveTestHistory(botId, payload)
        dispatch.contentModel.updateAutosolveTestHistory(response?.data?.data)
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get autosolve test history',
          type: 'failed',
        })
      }
    },

    listAppVersions: async ({ appId, type, isTemplate }: any) => {
      try {
        dispatch.contentModel.updateAppVersions(null)
        // dispatch.contentModel.updateContentLoading(true)
        let response;
        if (isTemplate) {
          response = await listTemplateVersion(appId)
        }
        else {
          response = await listAppVersions(appId, type)
        }
        dispatch.contentModel.updateAppVersions(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getBulkTestStatus: async ({ appId, execId, appname, type }: any) => {
      try {
        dispatch.contentModel.updateBulkRunStatus(null);

        const checkStatus = async (): Promise<any> => {
          const response = await getBulkTestStatus(appId, execId, type);

          if (
            response?.data?.data[0]?.execution_status === 'Completed' ||
            response?.data?.data[0]?.execution_status === 'Completed_With_Errors'
          ) {
            dispatch.contentModel.updateBulkRunStatus(true);
            dispatch.commonModel.updateNotificationState({
              message: 'Success',
              description: `Bulkrun is completed for ${appname}. You can download your results now.`,
              type: 'success',
            });
            dispatch.contentModel.updateBulkRunResultDynamic({
              ...response?.data?.data[0],
              appId: appId,
            });
          } else if (response?.data?.data[0]?.execution_status === 'Failed') {
            dispatch.commonModel.updateNotificationState({
              message: 'Failed',
              description: 'Failed To Execute BulkRun',
              type: 'failed',
            });
          } else if (response?.data?.data[0]?.execution_status === 'Terminated') {
            dispatch.commonModel.updateNotificationState({
              message: 'Success',
              description: 'Canceling bulkrun',
              type: 'success',
            });
            dispatch.contentModel.updateBulkRunResultDynamic({
              ...response?.data?.data[0],
              appId: appId,
            });
          } else {
            // Handle in-progress status
            dispatch.contentModel.updateBulkRunResultDynamic({
              ...response?.data?.data[0],
              appId: appId,
            });
            await new Promise((resolve) => setTimeout(resolve, 10000));
            const value = await checkStatus();
            return value;
          }
        };

        if (appId) {
          const response = await checkStatus();
          return response;
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false);
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Execute BulkRun',
          type: 'failed',
        });
      }
    },
    appToolShareTest: async ({ payload, appId }: any) => {
      try {
        //dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateTestStatus(true)

        const response = await testAppshareTool(payload, appId)
        const statusResponse = await statusChecker(response?.data?.statusQueryGetUri)
        const parsedResponse = JSON.parse(statusResponse?.output)
        if (parsedResponse) {
          if (parsedResponse?.error) {
            dispatch.commonModel.updateNotificationState({
              message: 'Failed',
              description: parsedResponse?.error,
              type: 'failed',
            })
          } else {
            dispatch.contentModel.updateTestStatus(false)
            dispatch.contentModel.updateChatMessage({
              isSent: false,
              text: parsedResponse?.content,
              pdf_url: parsedResponse?.pdf_url,
            })
          }
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Test App',
          type: 'failed',
        })
      }
      // dispatch.contentModel.updateContentLoading(false)
      dispatch.contentModel.updateTestStatus(false)
    },
    listRunHistory: async ({ appId, payload, pagination }) => {
      try {
        if (!pagination) {
          dispatch.contentModel.updateAppHistory(null)
        }
        //dispatch.contentModel.updateRunHistory(null)
        dispatch.contentModel.updateContentLoading(true)
        const response = await listRunHistory(appId, payload)
        if (pagination) {

          dispatch.contentModel.updateRunHistoryPagination(response?.data?.data)
        }
        else {
          dispatch.contentModel.updateRunHistory(response?.data?.data)
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    listTags: async () => {
      try {
        //dispatch.contentModel.updateTags(null)
        // dispatch.contentModel.updateContentLoading(true)
        const response = await listTags()
        dispatch.contentModel.updateTags(response?.data?.data)
        // dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list App Tags',
          type: 'failed',
        })
      }
    },
    getAppShareDetails: async ({ appId }) => {
      try {
        //dispatch.contentModel.updateContentLoading(true)
        const response = await getAppShareDetails(appId)

        dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        //dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    appShareLinkGeneration: async (payload) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await appShareLinkGeneration(payload)

        dispatch.contentModel.updateAppSharelinkGeneration(response?.data?.data?.appurl)
        dispatch.contentModel.updateContentLoading(false)
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Generate AppShare Link',
          type: 'failed',
        })
      }
    },

    appShareLinkValidation: async (payload) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await appShareLinkValidation(payload)

        dispatch.contentModel.updateAppShareLinkValidation(response?.data?.message)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Validate AppShare Link',
          type: 'failed',
        })
      }
    },
    bulkrunStatusApp: async (payload) => {
      try {
        //dispatch.contentModel.updateContentLoading(true)
        const response = await bulkrunStatusApp(payload)
        const data = response?.data?.data?.sort((a: any, b: any) => b.run_time - a.run_time)

        data
          ? dispatch.contentModel.updateBulkRunContent(data)
          : dispatch.contentModel.updateBulkRunContent([])

        //dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'failed',
          type: 'failed',
        })
      }
    },

    evalsRunStatus: async (payload) => {

      try {
        // dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateEvalsRunStatus(true)
        const response = await getEvalsRunStatus(payload)
        dispatch.contentModel.updateQueryUrl(response?.data)
        const statusResponse = await statusChecker(response?.data?.statusQueryGetUri)
        if (statusResponse.runtimeStatus === "Failed" || statusResponse.runtimeStatus === "Terminated") {
          dispatch.commonModel.updateNotificationState({
            message: statusResponse.runtimeStatus,
            description: statusResponse.error,
            type: 'failed',
          })
        } else {

          const rawOutput = statusResponse.output
          const parsedResponse = typeof rawOutput === 'string' ? (() => { try { return JSON.parse(rawOutput) } catch { return null } })() : rawOutput
          if (parsedResponse) {
            if (parsedResponse?.error) {
              dispatch.commonModel.updateNotificationState({
                message: 'Failed',
                description: parsedResponse.error,
                type: 'failed',
              })
            } else {
              dispatch.contentModel.updateParsedResponse(parsedResponse)
              dispatch.contentModel.updateEvalsRunStatus(false)
            }
          }
        }
      } catch (err) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Test App',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
      dispatch.contentModel.updateTestStatus(false)
    },

    getEvalDatasets: async (payload: { type: string; agent_id: string }) => {
      try {
        const response = await getEvalDatasets(payload.type, payload.agent_id)
        dispatch.contentModel.updateEvalDatasets(response?.data?.data || [])
        return response?.data
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch eval datasets',
          type: 'failed',
        })
        throw error
      }
    },

    getEvalHistory: async (payload: { type: string; agent_id: string }) => {
      try {
        const response = await getEvalHistory(payload.type, payload.agent_id)
        const historyData = response?.data?.data ?? response?.data ?? []
        dispatch.contentModel.updateEvalHistory(Array.isArray(historyData) ? historyData : [])
        return response?.data
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch eval history',
          type: 'failed',
        })
        throw error
      }
    },

    runEvalAgent: async (payload: { agent_id: string; dataset_name: string }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await runEvalAgent(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Eval run started successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to start eval run',
          type: 'failed',
        })
        throw error
      }
    },

    runEvalApp: async (payload: { app_id: string; dataset_name: string; id: string; dataset_id: string }) => {
      try {
        const response = await runEvalApp(payload)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Eval run started successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to start eval run',
          type: 'failed',
        })
        throw error
      }
    },
    createEvalDataset: async (payload: { name: string; app_id?: string; agent_id?: string }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        // Ensure at least one ID is provided
        if (!payload.app_id && !payload.agent_id) {
          throw new Error('Either app_id or agent_id must be provided')
        }
        const response = await createEvalDataset(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Dataset created successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create dataset',
          type: 'failed',
        })
        throw error
      }
    },
    VisionModalList: async () => {
      try {
        // same api is used for both LLM and Vision
        const response = await listVisionModels()
        if (response?.status === 200) {
          dispatch.contentModel.updateVisionModelList(response?.data?.data)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    VoiceModelList: async () => {
      // const payload = {
      //   "query": query,
      //   container: 'system_config_llm_model',
      // }

      try {
        // same api is used for both LLM and Vision
        const response = await listVoiceModels()
        if (response?.status === 200) {
          dispatch.contentModel.updateVisionModelList(response?.data?.data)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    uploadFilesusingLink: async (payload) => {
      // if no common message is needed pass suppressNotifications as true
      let suppressNotifications = false;
      if (payload instanceof FormData) {
        const dataString = payload.get('data');
        if (dataString && typeof dataString === 'string') {
          const parsedData = JSON.parse(dataString);
          suppressNotifications = parsedData.suppressNotifications === true;
        }
      }

      try {
        dispatch.contentModel.updatefileLoading(true)
        // Show loading notification only if not suppressed
        if (!suppressNotifications) {
          dispatch.commonModel.updateNotificationState({
            message: 'Uploading...',
            description: 'Please wait while your file is being uploaded',
            type: 'info',
          })
        }

        const response = await uploadFilesusingLink(payload)

        dispatch.contentModel.updateFileParams(response?.data?.data)

        // Extract file name from FormData for success message
        let fileName = 'file';
        if (payload instanceof FormData) {
          const dataString = payload.get('data');
          if (dataString && typeof dataString === 'string') {
            const parsedData = JSON.parse(dataString);
            fileName = parsedData.files?.[0] || 'file';
          }
        }

        // Show success notification only if not suppressed
        if (!suppressNotifications) {
          dispatch.commonModel.updateNotificationState({
            message: 'Upload Successful',
            description: `${fileName} has been uploaded successfully`,
            type: 'success',
          })
        }
        dispatch.contentModel.updatefileLoading(false)
        return response;
      } catch (error: any) {
        dispatch.contentModel.updatefileLoading(false)

        // Extract path and file info from FormData
        let path = '';
        let fileName = 'file';
        if (payload instanceof FormData) {
          const dataString = payload.get('data');
          if (dataString && typeof dataString === 'string') {
            const parsedData = JSON.parse(dataString);
            path = parsedData.path;
            fileName = parsedData.files?.[0] || 'file';
          }
        }

        // Show error notifications only if not suppressed
        if (!suppressNotifications) {
          // Provide more specific error messages based on context
          if (path && path.includes('most_likely_questions')) {
            dispatch.commonModel.updateNotificationState({
              message: 'CSV Format Error',
              description: 'CSV must contain columns: "questions" and "score". Please check the template for the correct format.',
              type: 'failed',
            })
          } else if (path && path.includes('past_tickets')) {
            dispatch.commonModel.updateNotificationState({
              message: 'CSV Format Error',
              description: 'CSV must contain columns: "ticket_id", "subject", "category", "priority", "raised_by", "created_on". Please check the template for the correct format.',
              type: 'failed',
            })
          } else if (path && path.includes('faq')) {
            dispatch.commonModel.updateNotificationState({
              message: 'CSV Format Error',
              description: 'CSV must contain columns: "question", "answer", "category". Please check the template for the correct format.',
              type: 'failed',
            })
          } else if (error?.response?.status === 413) {
            dispatch.commonModel.updateNotificationState({
              message: 'File Too Large',
              description: 'The file size exceeds the maximum allowed limit. Please compress or split the file.',
              type: 'failed',
            })
          } else if (error?.response?.status === 415) {
            dispatch.commonModel.updateNotificationState({
              message: 'Unsupported File Type',
              description: 'The file type is not supported. Please check the allowed file types and try again.',
              type: 'failed',
            })
          } else {
            dispatch.commonModel.updateNotificationState({
              message: 'Upload Failed',
              description: `Failed to upload ${fileName}. Please try again or contact support if the issue persists.`,
              type: 'failed',
            })
          }
        }
      }
    },
    uploadFilesInternal: async (payload) => {
      try {
        dispatch.contentModel.updatefileLoading(true)
        // Pass access-type header for internal test mode
        const customHeaders = { 'access-type': 'internal' }
        const response = await uploadFilesusingLink(payload, customHeaders)
        dispatch.contentModel.updateFileParams(response?.data?.data)
        dispatch.contentModel.updatefileLoading(false)
        return response;
      } catch (error: any) {
        dispatch.contentModel.updatefileLoading(false)
        throw error
      }
    },
    dispatchUploadInAppShare: async (payload) => {
      try {
        dispatch.contentModel.updatefileLoading(true)

        const response = await uploadFilesFromAppShare(payload)

        dispatch.contentModel.updateFileParams(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'File Upload Successful',
          type: 'success',
        })
        dispatch.contentModel.updatefileLoading(false)
      } catch (error: any) {
        dispatch.contentModel.updatefileLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: error?.message,
          type: 'failed',
        })
      }
    },
    uploadFileMultipleApps: async ({ fileInfo, name, appIds }) => {
      try {
        dispatch.contentModel.updateContentLoading(true);
        // Create an array of promises for each API call
        const uploadPromises = appIds?.map(async (item: any) => {
          const fileUploadPayload = {
            container_id: 1,
            path: item?.app_id,
            files: [
              `${name}`,
            ]
          };

          const formData = new FormData();
          const jsonData = JSON.stringify(fileUploadPayload);
          formData.append('data', jsonData);
          formData.append(name, fileInfo?.fileList[0]?.originFileObj);

          const response = await uploadFilesusingLink(formData);
          dispatch.contentModel.updateFileParams(response?.data?.data);

          return response; // Return the response to track success/failure
        });

        // Wait for all promises to resolve
        const uploadResults = await Promise.all(uploadPromises);
        // Check if all uploads were successful
        const allUploadsSuccessful = uploadResults.every(result => result && result.status === 200);

        if (allUploadsSuccessful) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'File Upload Successful',
            type: 'success',
          });
        } else {
          // Handle case where not all uploads were successful
          // Optionally display an error notification
          dispatch.commonModel.updateNotificationState({
            message: 'Error',
            description: 'FileUpload failed',
            type: 'error',
          });
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        // Handle error (e.g., display error notification)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'File upload failed',
          type: 'error',
        });
      }

      dispatch.contentModel.updateContentLoading(false)

    },
    generateSAStoken: async ({ payload, metadata, isGoogleDrive = false }) => {
      try {
        const { fileInfo, container_id, app_id, timestamp } = payload;

        const payloadForToken = {
          container_id: container_id,
          path: `${app_id}`,
        };

        dispatch.contentModel.updateContentLoading(true);
        const response = await generateSASurl(payloadForToken);



        if (response?.status === 200) {

          fileInfo.fileList.forEach((file: any) => {

            let uploadPromise;
            if (isGoogleDrive) {
              // Use the new function for Google Drive uploads
              uploadPromise = WizrAzurOrchestratorBulkRunwithUrl.uploadGoogleDriveFile(
                response?.data?.data?.url,
                response?.data?.data?.token,
                file,
                metadata,
                timestamp
              );
            } else {
              // Use the existing function for
              //  other uploads

              uploadPromise = WizrAzurOrchestratorBulkRunwithUrl.uploadFileWithUrl(

                response?.data?.data?.url,
                response?.data?.data?.token,
                file,
                [],
                '',
                metadata,
                timestamp
              );
            }

            uploadPromise
              .then((result) => {
                dispatch.contentModel.updatedUrlforCsvUpload(`${timestamp}/${file?.name}`);
              })
              .catch((error) => {
                // Handle the error here
              });
          });
        }
        dispatch.contentModel.updateContentLoading(false);
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false);
        // Handle error notification here if needed
      }
    },
    generateSASTokenForFileDownload: async ({ payload, name }) => {
      try {
        dispatch.contentModel.updateGenerateCode(``)
        const response = await generateSASurl(payload)
        const pageUrl = response.data.data.url

        // const pageUrl = `${domain}`
        window.open(pageUrl, '_blank');
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To SasToken',
          type: 'failed',
        })
      }
    },
    generateSASTokenGeneric: async (payload) => {
      try {
        // dispatch.contentModel.updateContentLoading(true)
        const response = await generateSASurl(payload)
        dispatch.contentModel.updateSasToken(response.data.data.token)
        // dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To SasToken',
          type: 'failed',
        })
      }
    },

    generateSAStokenToDownloadTemplate: async ({ payload, app_name }) => {
      try {
        dispatch.contentModel.updateDownloadLoading(true);
        const response = await generateSASurl(payload);
        const baseUrl = response.data.data.url;
        window.open(baseUrl, '_blank', 'noopener,noreferrer');
        dispatch.contentModel.updateDownloadLoading(false);
      } catch (error) {
        dispatch.contentModel.updateDownloadLoading(false);
      }
    },
    generateSAStokenToDownloadTemplateAiAgent: async ({ payload, app_name }) => {
      try {

        dispatch.contentModel.updateDownloadLoading(true);
        const response = await generateSASurl(payload);

        const baseUrl = response.data.data.url;
        const token = response.data.data.token;
        let azureSasUrl = baseUrl;
        if (!baseUrl.includes('?') && token) {
          azureSasUrl = `${baseUrl}?${token}`;
        }
        try {
          window.open(azureSasUrl, '_blank', 'noopener,noreferrer');
        } catch (err) {
          const link = document.createElement('a');
          link.href = azureSasUrl;
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        dispatch.contentModel.updateDownloadLoading(false);
      } catch (error) {
        dispatch.contentModel.updateDownloadLoading(false);
      }
    },
    terminateBulkrun: async (payload) => {
      try {
        const response = await terminateBulkrun(payload)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Bulkrun termination failed',
          type: 'failed',
        })
      }
    },
    terminateBulkrunforAutoSolve: async (url: any) => {
      try {
        const statusResponse = await fetch(url.replace('{text}', 'usercancelled'), {
          method: 'POST',
          headers: {
            'wizr-access-key': process.env.REACT_APP_API_AUTHORIZATION_HEADER_APIKEY_VALUE || '',
            'Content-Type': 'application/json'

          }
        });

        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Bulkrun terminated successfully',
          type: 'success',
        })
        dispatch.contentModel.updateAutosolverunbatchLoading(false)
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Terminate Bulkrun',
          type: 'failed',
        })
      }

      dispatch.contentModel.updateAutosolverunbatchLoading(false)
    },
    enduserapi: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await testAppTool(payload)
        const statusResponse = await statusChecker(response?.data?.statusQueryGetUri)
        const parsedResponse = JSON.parse(statusResponse)
        if (parsedResponse) {
          if (parsedResponse?.error) {
            dispatch.commonModel.updateNotificationState({
              message: 'Failed',
              description: parsedResponse?.error,
              type: 'failed',
            })
          } else {
            dispatch.contentModel.updateTestStatus(false)
            dispatch.contentModel.updateEnduser([parsedResponse?.content])
            // dispatch.contentModel.updateChatMessage({
            //   isSent: false,
            //   text: parsedResponse?.content,
            // })
          }
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Test App',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
      dispatch.contentModel.updateTestStatus(false)
    },
    executeBulkrun: async (payload) => {
      try {
        const response = await executeBulkrun(payload)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Bulkrun termination failed',
          type: 'failed',
        })
      }
    },
    appApiIntegrate: async (payload) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateAppApiUrl(null)
        const response = await appApiIntegrate(payload)
        dispatch.contentModel.updateAppApiUrl(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to generate app url',
          type: 'failed',
        })
      }
    },
    enableDisableUser: async (payload: any) => {
      try {
        const response = await enableDisableUser(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description:
              payload?.activation_status === 'enable'
                ? 'User enabled sucessfully'
                : 'User disabled sucessfully',
            type: 'success',
          })
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to change user status',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    listUsers: async (tenantType: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await listTenantUsers(tenantType)

        dispatch.contentModel.updateUserList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list users ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    emailInvite: async (payload: any) => {
      try {
        const response = await emailInvite(payload)
        dispatch.contentModel.updateEmailInvite(response?.data?.data)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Email invite sent successfully',
            type: 'success',
          })
        }
        dispatch.contentModel.updateContentLoading(false)

      } catch (error) {

        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to send email invite',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    updateUserDetails: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await updateUserDetails(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'User details updated sucessfully',
            type: 'success',
          })
          dispatch.contentModel.updateContentLoading(false)
          return true
        }

        dispatch.contentModel.updateContentLoading(false)
        return false
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update user details',
          type: 'failed',
        })
        return false
      }
    },
    createUser: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await createUser(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'User created sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create user ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    deleteUser: async (userId: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await deleteUser(userId)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'User removed sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete user ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getUserDetails: async (userId: any) => {
      try {
        dispatch.contentModel.updateCurrentuserDetails({})

        dispatch.contentModel.updateContentLoading(true)

        const response = await getUserDetails(userId)
        dispatch.contentModel.updateCurrentuserDetails(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get user details ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getTenantList: async (opts?: { skipContentLoading?: boolean }) => {
      const skipGlobalLoader = opts?.skipContentLoading === true
      const setGlobalLoading = (value: boolean) => {
        if (!skipGlobalLoader) dispatch.contentModel.updateContentLoading(value)
      }
      try {
        setGlobalLoading(true)

        const response = await getTenantList()

        dispatch.contentModel.updateTenantList(response?.data)
        setGlobalLoading(false)
      } catch (error) {
        setGlobalLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list tenants ',
          type: 'failed',
        })
      }
      setGlobalLoading(false)
    },
    createTenants: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await createTenants(payload)
        const statusResponse = await statusChecker(response?.data?.statusQueryGetUri)

        if (statusResponse) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Tenant created sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create tenant ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    updateTenants: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await updateTenants(payload)
        if (response) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Tenant updated sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update tenant ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getAccessList: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await getAccessList()

        dispatch.contentModel.updateAccessList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list accesses ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },

    getWorkspaceAccess: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await getWorkspaceAccess(payload)

        dispatch.contentModel.updateWorkspaceAccessList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)

        // Add success notification
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Workspace access updated successfully',
          type: 'success',
        })

      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list workspace accesses',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getRoleList: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await getRoleList()

        dispatch.contentModel.updateRolesList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list roles ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    deleteAccess: async (accessId: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await deleteAccess(accessId)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Access removed sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete access ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    createRole: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await createRole(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Role created sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create role ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    updateRole: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await updateRole(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Role updated sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update role ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    deleteRole: async (roleId) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await deleteRole(roleId)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Role removed sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete role ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getTenanatDetails: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getTenantDetails()
        dispatch.contentModel.updateTenantDetails(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch tenant details',
          type: 'failed',
        })
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    getPackageList: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await listPackages()

        dispatch.contentModel.updatePackageList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list packages ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getProductList: async (opts?: { skipContentLoading?: boolean }) => {
      const skipGlobalLoader = opts?.skipContentLoading === true
      const setGlobalLoading = (value: boolean) => {
        if (!skipGlobalLoader) dispatch.contentModel.updateContentLoading(value)
      }
      try {
        setGlobalLoading(true)

        const response = await listProducts()

        dispatch.contentModel.updateProductList(response?.data?.data)
        setGlobalLoading(false)
      } catch (error) {
        setGlobalLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list products ',
          type: 'failed',
        })
      }
      setGlobalLoading(false)
    },
    updateProduct: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await updateProducts(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Product updated sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update product ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    createPackage: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await createPackage(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Package created sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create package ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    updatePackages: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await updatePackages(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Package updated sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update package ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    deletePackage: async (packageId: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await deletePackages(packageId)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Package removed sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete package ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    deleteTenants: async (Id: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await deleteTenants(Id)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Tenant removed sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete tenant ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },

    disableTenant: async (Id: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await disableTenant(Id)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Tenant disabled sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to disable tenant ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    setPermissionValues: async (payload) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const permissions = await getAccessLists(payload)
        dispatch.contentModel.updatePermissionValues(permissions)
        dispatch.contentModel.updatePermissionsLoaded(true)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updatePermissionsLoaded(true)
        dispatch.contentModel.updateContentLoading(false)
        // dispatch.commonModel.updateNotificationState({
        //   message: 'Failed',
        //   description: 'Failed to set permission values',
        //   type: 'failed',
        // })
      }
    },
    enableTenant: async (Id: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await enableTenant(Id)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Tenant enabled sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to enable tenant ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getIntegrationList: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await listIntegrations()

        dispatch.contentModel.updateIntegrationList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list integrations ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },

    getMasterTenantIntegrations: async () => {
      try {
        dispatch.contentModel.updateInnerContentLoading(true)

        const response = await masterTenantIntegrations()

        dispatch.contentModel.updateMatserIntegrationList(response?.data?.data)
        dispatch.contentModel.updateInnerContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateInnerContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list integrations ',
          type: 'failed',
        })
      }
    },
    deleteIntegration: async (integrationId: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await deleteIntegration(integrationId)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Integration removed sucessfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete integrations ',
          type: 'failed',
        })
      }
    },
    updateIntegration: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateIntegration(payload)

        if (response?.data?.data?.success === false) {
          // Handle failure case
          dispatch.commonModel.updateNotificationState({
            message: response.message || 'Failed',
            description: response?.data?.data?.error || 'Integration failed',
            type: 'failed',
          })
        } else {
          // Handle success case
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Integration updated successfully',
            type: 'success',
          })
        }
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update integration',
          type: 'failed',
        })
      } finally {
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    createIntegration: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createIntegration(payload)

        if (response?.data?.data?.success === false) {
          // Handle failure case
          dispatch.commonModel.updateNotificationState({
            message: response.message || 'Failed',
            description: response?.data?.data?.error || 'Integration failed',
            type: 'failed',
          })
        } else {
          // Handle success case
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Integration created successfully',
            type: 'success',
          })
        }
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create integration',
          type: 'failed',
        })
      } finally {
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    listAppForPackage: async () => {
      try {
        const payload = {
          order: "desc",
          sort_by: "c.updated_on"
        }
        const response = await listAppForPackage(payload)
        dispatch.contentModel.updateAppData(response?.data?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list apps for package ',
          type: 'failed',
        })
      }
    },
    listAppGeneral: async () => {
      try {
        const payload = {
          order: "desc",
          sort_by: "c.updated_on"
        }
        const response = await listAppGeneral(payload)
        dispatch.contentModel.updateAppData(response?.data?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list apps for package ',
          type: 'failed',
        })
      }
    },
    getFeatureSettings: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getFeatureSettings()
        const featureSettingsData = response?.data?.data?.[0] || { feature_settings: [] }
        dispatch.contentModel.updateFeatureSettings(featureSettingsData)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to retrieve feature settings ',
          type: 'failed',
        })
      }
    },
    getAutosolveDashboard: async (payload: any) => {

      try {

        const response = await getAutosolveDashboard(payload)

        dispatch.contentModel.updateAutosolveDashboard(response?.data)


      } catch (error) {

        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get autosolve dashboard ',
          type: 'failed',
        })
      }
    },
    getAgentAssistDashboard: async (payload: any) => {
      try {
        const response = await getAgentAssistDashboard(payload)
        dispatch.contentModel.updateAgentAssistDashboard(response?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get autosolve dashboard ',
          type: 'failed',
        })
      }
    },
    getWorkflowDashboard: async (payload: any) => {
      try {
        const response = await getWorkflowDashboard(payload)
        dispatch.contentModel.updateWorkflowDashboard(response?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get workflow dashboard ',
          type: 'failed',
        })
      }
    },


    getHomeDashboardTotal: async (payload: any) => {
      try {
        const response = await getHomeDashboardTotal(payload)
        dispatch.contentModel.updateHomeDashboardTotal(response?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get home dashboard total ',
          type: 'failed',
        })
      }
    },
    updateFetaureSettingsStatus: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateFetaureSettingsStatus(payload)

        const status = payload?.feature_settings?.status
        if (status !== 'deleted') {
          dispatch.contentModel.updateContentLoading(false)
        }

        if (status === 'deleted') {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Feature deleted successfully',
            type: 'success',
          })
        } else if (status === 'active') {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Feature enabled successfully',
            type: 'success',
          })
        } else if (status === 'disabled') {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Feature disabled successfully',
            type: 'success',
          })
        } else {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Feature updated successfully',
            type: 'success',
          })
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update settings ',
          type: 'failed',
        })
      }
    },
    updateFetaureSettings: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateFeatureSettings(payload)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update settings ',
          type: 'failed',
        })
      }
    },
    createAutoSolveFeature: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createAutoSolveFeature(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Feature created successfully',
          type: 'success',
        })
        return { success: true, response }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create feature - name may already exist',
          type: 'failed',
        })
        return { success: false, error }
      }
    },
    createFeatureIntegrationSettings: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createFeatureIntegrationSettings(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Feature created sucessfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create feature ',
          type: 'failed',
        })
      }
    },
    cloneAutosolveFeature: async (payload: any) => {

      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await cloneAutosolveFeature(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Feature created sucessfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create feature ',
          type: 'failed',
        })
      }
    },
    // cloneAutosolveFeature: async (payload: any) => {

    //   try {
    //     dispatch.contentModel.updateContentLoading(true)
    //     const response = await createFeatureIntegrationSettings(payload?.feactureClone)
    //     if (response) {
    //       const filteredArray = response?.data?.data?.feature_settings?.filter((item: any) => item?.bot_id === payload?.botDetails?.bot_config?.id)
    //       const feature_id = filteredArray[0].id
    //       const botDetails = {
    //         ...payload?.botDetails,
    //         app_feature_id: feature_id
    //       }
    //       const createBotResponse = await createBot(botDetails)
    //     }
    //     dispatch.contentModel.updateContentLoading(false)
    //     dispatch.commonModel.updateNotificationState({
    //       message: 'Success',
    //       description: 'Feature created sucessfully',
    //       type: 'success',
    //     })
    //   } catch (error) {
    //     dispatch.contentModel.updateContentLoading(false)
    //     dispatch.commonModel.updateNotificationState({
    //       message: 'Failed',
    //       description: 'Failed to create feature ',
    //       type: 'failed',
    //     })
    //   }
    // },
    createFeatureIntegrationSettingsAutoSolve: async (data: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createFeatureIntegrationSettings(data?.finalPayload)
        const payloadBot = {
          ...data?.botDetails,
          app_feature_id: response?.data?.data?.id
        }
        const botPayload = {
          bot_config: {
            ...data?.botDetails?.bot_config,
            agent_id: data?.botDetails?.bot_config?.agent_id,
            bot_personality: data?.finalPayload?.feature_settings?.bot_config?.bot_personality
          },
          app_feature_id: response?.data?.data?.id,
          tenant_feature_id: data?.botDetails?.id,
        }
        const resposneBot = await createBot(payloadBot)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Feature created sucessfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create feature ',
          type: 'failed',
        })
      }
    },
    createGroupFolder: async ({ payload, type }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createGroupFolder(payload, type)
        dispatch.contentModel.updateContentLoading(false)
        if (payload?.data?.status !== 'deleted') {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Folder updated sucessfully',
            type: 'success',
          })
        }
        else {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Folder deleted sucessfully',
            type: 'success',
          })
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update Folder ',
          type: 'failed',
        })
      }
    },
    updateTicketType: async ({ payload, type }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateTicketType(payload, type)
        dispatch.contentModel.updateContentLoading(false)
        if (payload?.data?.status === 'deleted') {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Ticket Type deleted sucessfully',
            type: 'success',
          })
        }
        else {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Values updated sucessfully',
            type: 'success',
          })
        }

      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: `${error}`,
          type: 'failed',
        })
      }
    },
    updateCompanyInfo: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateCompanyInfo(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Company details updated sucessfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update company details ',
          type: 'failed',
        })
      }
    },
    updatePersona: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updatePersona(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Persona updated sucessfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update Persona ',
          type: 'failed',
        })
      }
    },
    setAsTemplate: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await setAsTemplate(payload)
        // dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'App set as template',
          type: 'success',
        })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to set template',
          type: 'failed',
        })
      }
    },
    updateTicketDetail: async (payload: any) => {
      try {
        dispatch.contentModel.updateTicketDetails(payload)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get ticket details',
          type: 'failed',
        })
      }
    },
    // getAutoTagList: async (type) => {
    //   try {
    //     const response = await getAutoTagList(type)
    //     dispatch.contentModel.updateAutoTagData(response?.data?.data)
    //   } catch (error) {
    //     dispatch.contentModel.updateContentLoading(false)
    //     dispatch.commonModel.updateNotificationState({
    //       message: 'Failed',
    //       description: 'Failed to list apps for package ',
    //       type: 'failed',
    //     })
    //   }
    // },
    getAutoTagList: async (type: any) => {
      try {
        const response = await getAutoTagList(type);


        if (type === 'autotag') {

          dispatch.contentModel.updateAutoTagData(response?.data?.data);
        } else {

          dispatch.contentModel.updateAgentTagData(response?.data?.data);
        }

      } catch (error) {
        // Handle the error scenario
        dispatch.contentModel.updateContentLoading(false);
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list apps for package',
          type: 'failed',
        });
      }
    },
    getFeatureAppDetails: async (appId: any) => {
      try {
        const response = await getFeatureAppDetails(appId)
        dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get feature app details ',
          type: 'failed',
        })
      }
    },
    getPacakageDetails: async (type: string) => {
      try {
        const response = await getPacakageDetails(type)
        switch (type) {
          case 'autotag':
            dispatch.contentModel.updateAppData(response?.data?.data)
            break
          case 'agentassist':
            dispatch.contentModel.updateAgentAssistData(response?.data?.data)
            break
          case 'autosolve':
            dispatch.contentModel.updateAppData(response?.data?.data)
            break
          case 'agenttag':
            dispatch.contentModel.updateAppData(response?.data?.data)
            break
          default:
            break
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get package app list ',
          type: 'failed',
        })
      }
    },
    getAppId: async (appId: any) => {

      try {
        if (appId) {
          const response = await getAppId(appId)

          dispatch.contentModel.updateAppId(response?.data)
          dispatch.contentModel.updateCurrentAppDetails(response?.data?.data)
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get app id',
          type: 'failed',
        })
      }
    },
    editFeatureSettings: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await updateFeatureSettings(payload)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Feature Settings Updated Successfully ',
          type: 'success',
        })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update feature settings ',
          type: 'failed',
        })
      }
    },
    getEndPointUrl: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await getEndPointUrl(payload)
        dispatch.contentModel.updateEndpointdata(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get endpoint url ',
          type: 'failed',
        })
      }
    },
    getTenantGroups: async (Id: any) => {
      try {
        dispatch.contentModel.updateTenantGroups('')

        const response = await getTenantGroups(Id)
        dispatch.contentModel.updateTenantGroups(response?.data?.data)
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to list teams ',
          type: 'failed',
        })
      }
    },
    saveTenantGroups: async (payload: any) => {
      try {
        const response = await saveTenantGroups(payload)
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to save teams ',
          type: 'failed',
        })
      }
    },
    createFolderFaqPT: async (payload: any) => {
      const response = await createFolder(payload)
    },
    getGroupRowDetails: async ({ type, folderId }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await getGroupRowDetails(type, folderId)
        dispatch.contentModel.updateFaqPtTicketDetails(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get group row details ',
          type: 'failed',
        })
      }
    },
    deleteGroupRowDetails: async ({ type, rowId }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await deleteGroupRowDetails(type, rowId)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete details ',
          type: 'failed',
        })
      }
    },
    deleteGroupsFaqPastTickets: async ({ type, folderId }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await deleteGroupsFaqPastTickets(type, folderId)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete details ',
          type: 'failed',
        })
      }
    },
    getIntegrationToolsForTenant: async () => {
      const response = await getIntegrationToolsForTenant()
      dispatch.contentModel.updateMatserIntegrationList(response?.data?.data)

    },

    getIntegrationsForSelectedTool: async (tools: any) => {
      dispatch.contentModel.updateIntegrationList([])

      const response = await getIntegrationsForSelectedTool(tools)
      dispatch.contentModel.updateIntegrationList(response?.data?.data)

    },
    embeddingModelList: async () => {
      try {
        // same api is used for both LLM and Vision
        const response = await listEmbeddingModels()
        if (response?.status === 200) {
          dispatch.contentModel.updateEmbeddingModelList(response?.data?.data)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)

      }
    },
    getCxAutosolveFilter: async () => {

      try {
        const response = await getCxAutosolveFilter()
        dispatch.contentModel.updateCxAutosolveFilter(response?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx autosolve filter',
          type: 'failed',
        })
      }
    },
    getcustomerInteractionAutosolveHistory: async (payload: any) => {

      try {
        const response = await customerInteractionAutosolveHistory(payload)
        dispatch.contentModel.updatecustomerInteractionAutosolveHistory(response?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx autosolve filter',
          type: 'failed',
        })
      }
    },

    getSingleConversationData: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await customerInteractionAutosolveHistory(payload)
        dispatch.contentModel.updateSingleConversationData(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get conversation details',
          type: 'failed',
        })
      }
    },
    getCxAgentAssistFilter: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getCxAgentAssistFilter()
        dispatch.contentModel.updateCxAgentAssistFilter(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx agent assist filter',
          type: 'failed',
        })
      }
    },

    getcustomerInteractionAgentAssistHistory: async (payload: any) => {
      dispatch.contentModel.updateContentLoading(true)

      try {

        dispatch.contentModel.updateIsAgentAssistTableLoading(true)
        const response = await customerInteractionAgentAssistHistory(payload)
        dispatch.contentModel.updatecustomerInteractionAgentAssistHistory(response?.data)
        dispatch.contentModel.updateIsAgentAssistTableLoading(false)
      } catch (error) {
        dispatch.contentModel.updateIsAgentAssistTableLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx autosolve filter',
          type: 'failed',
        })
      }
    },
    getSingleAgentAssistConversationData: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await customerInteractionAgentAssistHistory(payload)
        dispatch.contentModel.updateSingleAgentAssistConversationData(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get conversation details',
          type: 'failed',
        })
      }
    },

    // getcustomerInteractionAgentAssistHistory: async (payload: any) => {
    //   try {
    //     dispatch.contentModel.updateInnerContentLoading(true);
    //     const response = await customerInteractionAgentAssistHistory(payload);

    //     if (payload?.conversation_id) {
    //       dispatch.contentModel.updatecustomerInteractionAgentAssistHistorySelected(response?.data);
    //     } else {
    //       dispatch.contentModel.updatecustomerInteractionAgentAssistHistory(response?.data);
    //     }

    //     dispatch.contentModel.updateInnerContentLoading(false);
    //   } catch (error) {
    //     dispatch.contentModel.updateInnerContentLoading(false);
    //     dispatch.commonModel.updateNotificationState({
    //       message: 'Failed',
    //       description: 'Failed to get cx agentassist history',
    //       type: 'failed',
    //     });
    //   } finally {
    //     dispatch.contentModel.updateInnerContentLoading(false);
    //   }
    // },
    getLiveAgentNotifications: async (payload: any) => {

      try {
        const response = await getLiveAgentNotifications(payload)
        dispatch.contentModel.updateLiveAgentNotifications(response?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx autosolve filter',
          type: 'failed',
        })
      }
    },
    LiveAgentEndCall: async (payload: any) => {
      try {
        const response = await liveAgentEndCall(payload)
        return response
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx autosolve filter',
          type: 'failed',
        })
      }
    },
    updateactiveliveagent: async (payload: any) => {
      try {
        const response = await updateactiveliveagent(payload)
        return response
      } catch (error) {
        throw error
      }
    },
    removeactiveliveagent: async (payload: any) => {
      try {
        const response = await removeactiveliveagent(payload)
        return response
      } catch (error) {
        throw error
      }
    },
    getCxAutosolveDownload: async (payload: any) => {
      try {
        const response = await getCxAutosolveDownload(payload)
        const url = response?.data?.file_url
        window.open(url)
      } catch (error) {
        throw error
      }
    },
    getCxAgentAssistDownload: async (payload: any) => {
      try {
        const response = await getCxAgentAssistDownload(payload)
        const url = response?.data?.file_url
        window.open(url)
      } catch (error) {
        throw error
      }
    },
    getCxAgentAssistCardDetails: async (payload: any) => {
      try {
        dispatch.contentModel.updateIsAgentAssistCardsLoading(true)
        const response = await getCxAgentAssistCardDetails(payload)
        dispatch.contentModel.updateCxAgentAssistCardDetails(response?.data)
        dispatch.contentModel.updateIsAgentAssistCardsLoading(false)
      } catch (error) {
        dispatch.contentModel.updateIsAgentAssistCardsLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx agent assist cards',
          type: 'failed',
        })
      }
    },
    getCxAutosolveFourCards: async (payload: any) => {
      try {
        const response = await getCxAutosolveFourCards(payload)
        dispatch.contentModel.updateCxAutosolveFourCards(response?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get cx autosolve four cards',
          type: 'failed',
        })
      }
    },
    // Seeker effects
    getCxSeekerCards: async (payload: any) => {
      try {
        dispatch.contentModel.updateIsSeekerCardsLoading(true)
        const response = await getCxSeekerCards(payload)
        dispatch.contentModel.updateCxSeekerCardDetails(response?.data)
        dispatch.contentModel.updateIsSeekerCardsLoading(false)
      } catch (error) {
        dispatch.contentModel.updateIsSeekerCardsLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get Seeker cards data',
          type: 'failed',
        })
      }
    },
    getCxSeekerHistoryList: async (payload: any) => {
      try {
        dispatch.contentModel.updateIsSeekerTableLoading(true)
        const response = await getCxSeekerHistoryList(payload)
        dispatch.contentModel.updateCxSeekerHistoryData(response?.data)
        dispatch.contentModel.updateIsSeekerTableLoading(false)
      } catch (error) {
        dispatch.contentModel.updateIsSeekerTableLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get Seeker history data',
          type: 'failed',
        })
      }
    },
    downloadCxSeekerCsv: async (payload: any) => {
      try {
        const response = await downloadCxSeekerCsv(payload)
        const url = response?.data?.file_url
        window.open(url)
      } catch (error) {
        throw error
      }
    },
    updateCxSeekerFeedback: async (payload: any) => {
      try {
        const response = await updateCxSeekerFeedback(payload)
        dispatch.contentModel.updateSeekerFeedbackUpdate(response?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Feedback updated successfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update feedback',
          type: 'failed',
        })
      }
    },
    getCxSeekerConversationDetails: async (payload: any) => {
      try {
        dispatch.contentModel.updateIsSeekerConversationLoading(true)
        const response = await getCxSeekerHistoryList(payload)
        dispatch.contentModel.updateCxSeekerConversationDetails(response?.data)
        dispatch.contentModel.updateIsSeekerConversationLoading(false)
      } catch (error) {
        dispatch.contentModel.updateIsSeekerConversationLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get conversation details',
          type: 'failed',
        })
      }
    },
    executeSeekerPinotQuery: async (payload: any) => {
      try {
        dispatch.contentModel.updateIsSeekerPinotQueryLoading(true)
        const response = await executePinotQuery(payload)
        dispatch.contentModel.updateCxSeekerPinotQueryResults(response?.data)
        dispatch.contentModel.updateIsSeekerPinotQueryLoading(false)
        return response?.data
      } catch (error) {
        dispatch.contentModel.updateIsSeekerPinotQueryLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to execute query',
          type: 'failed',
        })
      }
    },
    importPastTickets: async (payload: any) => {
      try {
        // same api is used for both LLM and Vision
        const response = await importPastTickets(payload)
        if (response?.status === 200) {
          // dispatch.contentModel.importPastTickets(payload)
        }
      } catch (err) {
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    topIntentsQuery: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTopIntents(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    getSubscriptionDetails: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getSubscriptionDetails()
        dispatch.contentModel.updateSubscriptionDetails(response?.data?.data?.subscription_key?.PrimaryKey)
        dispatch.contentModel.updateContentLoading(false)
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get subscription details ',
          type: 'failed',
        })
      }
    },
    updateTelemetry: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateTelemetry(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: payload?.status === 'enabled'
              ? 'Telemetry enabled successfully'
              : 'Telemetry disabled successfully',
            type: 'success',
          })
        }
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update telemetry status',
          type: 'failed',
        })
      }
    },
    topIncreasedIntenetQuery: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTopIncreasedIntents(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    topDecreasedIntentQuery: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTopDecreasedIntents(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    totalIntentsCountQuery: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTotalIntents(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    ticketsBasedonIntent: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTicketsBasedonIntent(response?.data)
        dispatch.contentModel.updateContentLoading(false)
        return response;
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    IntentsGraphData: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateIntentsGraphData(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    IntentsLists: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateIntentsList(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    TimeToResponse: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTimeResponse(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    TimeToResolve: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTimeResolve(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    TicketEscallation: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateTicketEscallation(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    FirstContactResolution: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateFirstContactResolution(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    CommonTags: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateCommonTags(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    listAllIntents: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomApi(payload)
        dispatch.contentModel.updateListAllIntents(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
          type: 'failed',
        })
      }
    },
    deleteTicketsFaqPt: async ({ rowId, type }: any) => {
      try {
        const response = await deleteTicketsFaqPt(rowId, type)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    testChatBot: async (payload: any) => {

      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await testChatBot(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.contentModel.updateChatMessage({
          isSent: false,
          text: response?.data?.response,
          liked: false,
          disliked: false,
          knowledgeBase: response?.data?.docs_metadata
        })
        dispatch.contentModel.updateChatBotHistory(response?.data?.history)

      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)

      }

    },
    controlroomFilerValues: async (payload: any) => {
      dispatch.contentModel.updateControlroomFilerValues(payload)

    },
    testChatBotAdithyaBirla: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await testChatBotAdithyaBirla(payload)
        dispatch.contentModel.updateContentLoading(false)

        dispatch.contentModel.updateChatMessage({
          isSent: false,
          text: response?.data?.response,
          liked: false,
          disliked: false,
          knowledgeBase: response?.data?.docs_metadata

        })
        dispatch.contentModel.updateChatBotHistory(response?.data?.history)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
      }

    },
    appInsights: async ({ payload, appType }: { payload: any; appType: any }) => {
      try {
        dispatch.contentModel.updateAppInsightsList([])
        dispatch.contentModel.updateIsAppInsightsLoading(true)
        const response = await appInsights(payload, appType)
        dispatch.contentModel.updateAppInsightsList(response?.data?.data)
        dispatch.contentModel.updateIsAppInsightsLoading(false)
      } catch (error) {
        dispatch.contentModel.updateIsAppInsightsLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To fetch details',
        })
      }
    },
    listWidgets: async () => {
      try {
        dispatch.contentModel.updateWidgetList([]);
        dispatch.contentModel.updateIsListWidgetsLoading(true)
        const response = await listWidgets()
        dispatch.contentModel.updateWidgetList(response?.data?.data)
        dispatch.contentModel.updateIsListWidgetsLoading(false)
      } catch (error) {
        dispatch.contentModel.updateIsListWidgetsLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list widgets',
          type: 'failed',
        })
      }
    },
    getBotDetails: async (botId: any) => {
      try {
        dispatch.contentModel.upateBotContentLoading(true)
        dispatch.contentModel.updateBotDetails([])
        const response = await getBotDetails(botId)
        dispatch.contentModel.updateBotDetails(response?.data?.data)
        dispatch.contentModel.upateBotContentLoading(false)
      } catch (error) {
        dispatch.contentModel.upateBotContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get bot details ',
        })
      }
    },

    getwidgetObjectDetails: async (bot_key: any) => {
      try {
        dispatch.contentModel.updateWidgetObjectDetails([])
        const response = await getwidgetObjectDetails(bot_key)
        dispatch.contentModel.updateWidgetObjectDetails(response.data)
      } catch (error) {

      }
    },

    getActiveEnterPriseHubList: async () => {
      try {
        const response = await getActiveEnterPriseHubList()
        dispatch.contentModel.updateEnterPriseHubActiveList(response.data)
      } catch (error) {

      }
    },

    getExHubHistory: async (payload: any) => {
      try {
        const response = await getExHubHistory(payload)
        dispatch.contentModel.updateExHubHistoryList(response?.data?.data)
      } catch (error) {

      }
    },
    updateEnterPriseHubList: async (payload: any) => {

      try {
        const response = await updateEnterPriseHub(payload)
      } catch (error) {

      }
    },


    listWidgetTypes: async () => {
      try {
        const response = await listWidgetTypes()
        dispatch.contentModel.updateWidgetTypes(response?.data?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list widget types',
          type: 'failed',
        })
      }
    },
    updateBot: async ({ payload, type, showupdate = true }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateBot(payload)
        dispatch.contentModel.updateBotDetails(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
        if (!type) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Agent updated successfully',
            type: 'success',
          })
        }
        return response
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Bot Failed ',
          type: 'failed',
        })
        throw error
      }
    },
    createWidget: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createWidget(payload)
        dispatch.contentModel.updateWidgetDetails(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Widget saved successfully',
          type: 'success',
        })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list widget types',
          type: 'failed',
        })
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    updateWidget: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateWidget(payload)
        dispatch.contentModel.updateWidgetDetails(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Widget updated successfully',
          type: 'success',
        })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list widget types',
          type: 'failed',
        })
        dispatch.contentModel.updateContentLoading(false)
      }
    },
    testWidget: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await testWidget(payload)
        dispatch.contentModel.updateChatMessage({
          isSent: false,
          text: response?.data?.data?.response,
          knowledgeBase: response?.data?.data?.docs_metadata
        })
        dispatch.contentModel.updateContentLoading(false)
        // dispatch.contentModel.updateWidgetChat(response?.data?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To test widget',
          type: 'failed',
        })
      }
    },
    getMcpTools: async (payload: any) => {
      try {
        const response = await getMcpTools(payload)
        return response
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch MCP tools',
          type: 'failed',
        })
        throw error
      }
    },
    testAutoSolveBot: async ({ payload, errorMessage }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await testBot(payload)
        dispatch.contentModel.updateContentLoading(false)
        const time = getCurrentTimeChatBot()
        if (response?.data?.status === 200) {
          dispatch.contentModel.updateChatMessage({
            isSent: false,
            text: response?.data?.data?.response,
            liked: false,
            disliked: false,
            knowledgeBase: response?.data?.data?.docs_metadata,
            time: time

          })
        }
        else {
          dispatch.contentModel.updateChatMessage({
            isSent: false,
            text: errorMessage ? errorMessage : "Oops I'm sorry I couldn't generate response for that.",
            liked: false,
            disliked: false,
            knowledgeBase: response?.data?.docs_metadata,
            time: time
          })
          dispatch.contentModel.updateContentLoading(false)
        }
      }
      catch (error) {
        const time = getCurrentTimeChatBot()
        dispatch.contentModel.updateChatMessage({
          isSent: false,
          text: errorMessage ? errorMessage : "Oops I'm sorry I couldn't generate response for that.",
          liked: false,
          disliked: false,
          // knowledgeBase: response?.data?.docs_metadata,
          time: time
        })
        dispatch.contentModel.updateContentLoading(false)
      }
      // dispatch.contentModel.updateChatBotHistory(response?.data?.history)
    },
    getAgentList: async (payload: any) => {
      dispatch.contentModel.updateAgentLoading(true)
      const { tenant_feature_id, app_feature_id } = payload;
      try {
        const response = await getAgentList(tenant_feature_id, app_feature_id)
        dispatch.contentModel.updateAgentLoading(false)

        dispatch.contentModel.updateAgentList(response?.data?.data)

      } catch (error) {
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list agents',
          type: 'failed',
        })
      }

    },
    getAgentVersions: async (agent_id: any) => {
      dispatch.contentModel.updateAgentLoading(true)
      try {
        const response = await getAgentVersions(agent_id)
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.contentModel.updateAgentVersions(response?.data?.data || [])
      } catch (error) {
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch agent versions',
          type: 'failed',
        })
      }
    },
    getDefaultAgent: async (agent_id: any) => {
      dispatch.contentModel.updateAgentLoading(true)
      try {
        const response = await getDefaultAgent(agent_id)
        dispatch.contentModel.updateAgentLoading(false)
        const agentData = response?.data?.data
        // Store the agent details in redux so CreateAgent can use it
        if (agentData) {
          dispatch.contentModel.updateAgent(agentData)
        }
        return { success: true, data: agentData }
      } catch (error) {
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch default agent',
          type: 'failed',
        })
        return { success: false, error }
      }
    },
    setAgentDefault: async (payload: any) => {
      dispatch.contentModel.updateAgentLoading(true)
      try {
        const response = await setAgentDefault(payload)
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Agent version set as default successfully',
          type: 'success',
        })
        // Refresh agent versions after setting default
        if (payload.agent_id) {
          dispatch.contentModel.getAgentVersions(payload.agent_id)
        }
        return { success: true, response }
      } catch (error) {
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to set agent version as default',
          type: 'failed',
        })
        return { success: false, error }
      }
    },
    publishAgent: async (payload: any) => {
      dispatch.contentModel.updateAgentLoading(true)
      try {
        const response = await publishAgent(payload)
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Agent version published successfully',
          type: 'success',
        })
        // Refresh agent versions after publishing
        if (payload.agent_id) {
          dispatch.contentModel.getAgentVersions(payload.agent_id)
        }
        return { success: true, response }
      } catch (error) {
        dispatch.contentModel.updateAgentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to publish agent version',
          type: 'failed',
        })
        return { success: false, error }
      }
    },
    getInstallationList: async () => {
      const response = await getInstallationList()
      dispatch.contentModel.updateListInstallation(response?.data?.data)
    },
    createAgent: async (payload: any) => {

      try {
        dispatch.contentModel.updateContentLoading(true)
        const responseAgent = await createAgent(payload)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.contentModel.updateAgent(responseAgent?.data?.data)
        return responseAgent
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        throw error
      }


    },
    createBot: async (payload: any) => {
      try {
        const response = await createBot(payload)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Agent created successfully',
          type: 'success',
        })
        return { success: true, response }
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create agent',
          type: 'failed',
        })
        return { success: false, error }
      }
    },
    updateAgentValues: async ({ payload, supervisor_data = false }: any) => {
      try {
        const response = await updateAgentApi(payload)
        if (!supervisor_data) {
          dispatch.contentModel.updateAgent(response?.data?.data)
        }

        // dispatch.commonModel.updateNotificationState({
        //   message: 'Success',
        //   description: 'Agent updated successfully',
        //   type: 'success',
        // })
        return response
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To update agents',
          type: 'failed',
        })
        throw error
      }
    },
    deleteAgent: async (payload: any) => {
      try {
        const response = deleteAgent(payload)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Agent deleted successfully',
          type: 'success',
        })
      } catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To delete agents',
          type: 'failed',
        })
      }

    },
    deleteWidget: async (payload: any) => {
      try {
        const response = await deleteWidget(payload)
        if (response?.data?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Widget deleted successfully',
            type: 'success',
          })
        }
        else {
          dispatch.commonModel.updateNotificationState({
            message: 'Failed',
            description: response.message,
            type: 'failed',
          })
        }
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete widget',
          type: 'failed',
        })
      }
    },
    getWidgetDetails: async (payload: any) => {
      try {
        const response = await getWidgetDetails(payload)
        dispatch.contentModel.updateWidgetDetails(response?.data?.data)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list widget types',
          type: 'failed',
        })
      }
    },
    getBotTestHistoryWebFormat: async ({ bot_id, id, headers }: any) => {
      try {
        dispatch.contentModel.updateChatBotHistoryLoader(true);

        const url = `${headers?.domain}/ai-bot/v1/bot/test_history/${bot_id}?conversation_id=${id}`;
        try {
          const response = await axios.get(url, {
            headers: {
              "Wizr-Access-Key": headers?.wizr_access_key,
              "Tenant-Id": headers?.tenant_id,
              "User-Id": id,
              "User-Name": id
            },
          });
          // const response = await getBotTestHistory(bot_id,id)


          // const data = response?.data?.data?.filter((item:any) => item.user_id === id);
          const data = response?.data?.data;


          if (data && data.length > 0) {
            data.map((item: any) => {
              const botInput = JSON.parse(item.bot_input);
              const botOutput = JSON.parse(item.bot_output);
              const sortedData = botOutput &&
                botOutput?.docs_metadata

              const array = {
                isSent: false,
                question: botInput?.user_query,
                text: botOutput?.agent_response
                  ? botOutput?.agent_response
                  : "No response",

                knowledgeBase: sortedData && sortedData.slice(0, 5),
                id: item?.history_id,
                history_id: item?.history_id

              };
              dispatch.contentModel.updateChatMessage({
                isSent: false,
                question: botInput?.user_query,
                text: botOutput?.agent_response
                  ? botOutput?.agent_response
                  : "No response",

                feedback: item?.feedback,
                knowledgeBase: sortedData && sortedData.slice(0, 5),
                id: item?.history_id,
                history_id: item?.history_id
              });
            });
          } else {
          }
          dispatch.contentModel.updateAppHistory(response?.data?.data);
        } catch (error) {
          throw error;
        }
      } catch (err) {
        dispatch.commonModel.updateNotificationState({
          message: "Failed",
          description: "Error in API call",
          type: "failed",
        });
      }
      dispatch.contentModel.updateChatBotHistoryLoader(false);
    },
    saveFeedback: async ({ payload, user_id, headers }: any) => {
      const url = `${headers?.domain}/ai-bot/v1/bot/feedback`;
      const response = await axios.post(url, payload, {
        headers: {
          "Wizr-Access-Key": headers?.wizr_access_key,
          "Tenant-Id": headers?.tenant_id,
          "User-Id": user_id,
          "User-Name": user_id
        },
        timeout: 600000,
      });
    },
    testApp: ({ appPayload, headers }: any) => {
      dispatch.contentModel.updateCleanupResponse('')

      // const urlApp = `https://wizr-one-api-manager.azure-api.net/app-execute/${appPayload?.app_id}/execute`;
      const urlApp = `${headers?.domain}/app-execute/v1/${appPayload?.app_id}/execute`;
      axios
        .post(urlApp, appPayload, {
          headers: {
            "Wizr-Access-Key": headers?.wizr_access_key,
            "Tenant-Id": headers?.tenant_id,
            "User-Id": appPayload?.app_id,
            "User-name": appPayload?.app_id

          },
        })
        .then((response) => {
          if (response) {
            statusChecker(response.data.statusQueryGetUri)
              .then((result) => {
                const response = JSON.parse(result)
                dispatch.contentModel.updateCleanupResponse(result)

                const parsedResponse = JSON.parse(response)

                dispatch.contentModel.updateLearnMore(response)
                //learnMore = result;
              })
              .catch((error) => {
              });
            dispatch.contentModel.updateTerminateUrl(response.data.terminatePostUri)
          }
        })
        .catch((error) => {
        });

      const statusChecker = async (url: string) => {
        const checkStatus = async (): Promise<any> => {
          const statusResponse = await fetch(url);
          const statusResponseJson = await statusResponse.json();
          if (
            statusResponseJson.runtimeStatus === "Running" ||
            statusResponseJson.runtimeStatus === "Pending"
          ) {
            await new Promise((resolve) => setTimeout(resolve, 5000));
            const value = await checkStatus();
            return value;
          } else {
            return statusResponseJson?.output;
          }
        };
        if (url) {
          const response = await checkStatus();
          return response;
        }
      };
    },
    getBotRunHistory: async (payload: any) => {
      try {

        dispatch.contentModel.updateContentLoading(true)
        const response = await getBotRunHistoryDetails(payload)
        dispatch.contentModel.updateAutosolveRunHistoryDetails(response?.data?.data)
        // dispatch.commonModel.updateNotificationState({
        //   message: 'Success',
        //   description: 'Conversation History fetched succesfully',
        //   type: 'success',
        // })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list history',
          type: 'failed',
        })
      }
    },
    getBotRunHistoryofConversation: async (payload: any) => {
      try {
        dispatch.contentModel.updateAutosolveRunHistoryDetailsOfConversation([])
        const { bot_id, conversationId } = payload
        dispatch.contentModel.updateInnerContentLoading(true)
        const response = await getBotRunHistoryDetailsOfACoversation(bot_id, conversationId)
        dispatch.contentModel.updateAutosolveRunHistoryDetailsOfConversation(response?.data?.data)
        // dispatch.commonModel.updateNotificationState({
        //   message: 'Success',FF
        //   description: 'Conversation History fetched succesfully',
        //   type: 'success',
        // })
        dispatch.contentModel.updateInnerContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateInnerContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list history',
          type: 'failed',
        })
      }
    },
    getAgentConversationList: async ({ payload, filter, isfeedback, initial }: any) => {
      try {

        dispatch.contentModel.updateInnerContentLoading(true)
        const keys = Object.keys(payload)
        let finalPayload;
        if (keys.includes('app_setting_name') || keys.includes('agent_name') || keys.includes('feedback') || initial) {//initial is for initial call
          finalPayload = payload; // Use the original payload
        } else {
          finalPayload = { ...payload, filter_type: 'default' }; // Add filter_type: 'default'
        }

        const response = await listAgentConversations(finalPayload)

        if (filter) {
          dispatch.contentModel.updateAgentConversationPagination(response?.data?.data?.history)
        }
        else {
          dispatch.contentModel.updateAgentConversationList(response?.data?.data?.history)
          !isfeedback && dispatch.contentModel.updateAgentTotalConversationCount(response?.data?.data?.total_count)

          !isfeedback && dispatch.contentModel.updateAgentTotalUpvoteCount(response?.data?.data?.upvote_total_count)
          !isfeedback && dispatch.contentModel.updateAgentTotalDownvoteCount(response?.data?.data?.downvote_total_count)
          // dispatch.commonModel.updateNotificationState({
          //   message: 'Success',
          //   description: 'Conversation History fetched succesfully',
          //   type: 'success',
          // })
        }
        dispatch.contentModel.updateInnerContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateInnerContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list Agent Conversation history',
          type: 'failed',
        })
      }
    },
    getAgentAssistConversationDetail: async (payload: any) => {

      try {

        dispatch.contentModel.updateInnerContentLoading(true)

        console.log('payload', payload)
        const response = await getAgentConversationDetail(payload?.conversationId)

        dispatch.contentModel.updateAgentConversationDetail(response?.data?.data)
        console.log('response ====', response?.data?.data)
        // dispatch.commonModel.updateNotificationState({
        //   message: 'Success',
        //   description: 'Conversation History fetched succesfully',
        //   type: 'success',
        // })
        dispatch.contentModel.updateInnerContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateInnerContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list history',
          type: 'failed',
        })
      }
    },

    getlistScheduler: async ({ payload, filter }: any) => {
      try {
        dispatch.contentModel.updateInnerContentLoading(true);
        const response = await listScheduler(payload);
        if (filter) {
          dispatch.contentModel.updateSchedulerListPagination(response?.data?.data?.results);


        } else {
          dispatch.contentModel.updateListScheduler(response?.data?.data?.results);

        }
        dispatch.contentModel.updateInnerContentLoading(false);

      } catch (error) {
      } finally {
        dispatch.contentModel.updateInnerContentLoading(false);
      }
    },
    getAgentAssistFilterDetails: async () => {
      try {
        dispatch.contentModel.updateInnerContentLoading(true)
        const response = await getAgentAssistFilterDetails()
        dispatch.contentModel.updateAgentAssistFilterDetails(response?.data?.data)
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get filter details',
          type: 'failed',
        })
      }
    },
    getAutosolveConversationDetail: async ({ payload, filter, isfeedback }: any) => {
      try {
        dispatch.contentModel.updateInnerContentLoading(true)


        const keys = Object.keys(payload)

        let finalPayload;
        if (keys.includes('bot_id') || keys.includes('source') || keys.includes('feedback')) {
          finalPayload = payload; // Use the original payload
        } else {
          finalPayload = { ...payload, filter_type: 'default' }; // Add filter_type: 'default'
        }
        const response = await getAutosolveConversations(finalPayload)
        if (filter) {
          dispatch.contentModel.updateAutosolveConversationPagination(response?.data?.data?.conversation_list)
          //  !isfeedback && dispatch.contentModel.updateTotalConversationCount(response?.data?.data?.total_count)
          //   !isfeedback && dispatch.contentModel.updateTotalUpvoteCount(response?.data?.data?.upvote_total_count)
          //   !isfeedback && dispatch.contentModel.updateTotalDownvoteCount(response?.data?.data?.downvote_total_count)
        }
        else {
          dispatch.contentModel.updateAutosolveConversation(response?.data?.data?.conversation_list)
          !isfeedback && dispatch.contentModel.updateTotalConversationCount(response?.data?.data?.total_count)
          !isfeedback && dispatch.contentModel.updateTotalUpvoteCount(response?.data?.data?.upvote_total_count)
          !isfeedback && dispatch.contentModel.updateTotalDownvoteCount(response?.data?.data?.downvote_total_count)

        }
        // dispatch.commonModel.updateNotificationState({
        //   message: 'Success',
        //   description: 'Conversation History fetched succesfully',
        //   type: 'success',
        // })
        dispatch.contentModel.updateInnerContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateInnerContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To list history',
          type: 'failed',
        })
      }
    },
    generateCode: async (payload: any) => {
      try {
        dispatch.contentModel.updateGenerateCode('')
        dispatch.contentModel.updateContentLoading(true)
        const response = await generateCode(payload)
        dispatch.contentModel.updateGenerateCode(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)

      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To generate code',
          type: 'failed',
        })
      }
    },
    getAutosolveMetaData: async () => {
      try {
        dispatch.contentModel.updateAutosolveMetaData(true)
        const response = await getAutoSolveMetaData()
        dispatch.contentModel.updateAutosolveMetaData(response?.data?.data)



      } catch (error) {
        dispatch.contentModel.updateAutosolveMetaData(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create feature ',
          type: 'failed',
        })
      }
    },
    saveFeedbackAutoSolve: async (payload: any) => {
      // const domain = process.env.REACT_APP_API_AUTO_SOLVE_BOT_FEEDBACK;
      // const url:any = domain
      // const response = await axios.post(url, payload, {
      //   headers: {
      //     "Wizr-Access-Key":headers?.wizr_access_key,
      //     "Tenant-Id": headers?.tenant_id,
      //     "User-Id" : user_id,
      //     "User-Name" : user_id
      //   },
      //   timeout: 600000,
      // });
      const response = await saveFeedBackAutoSolve(payload)

    },
    downloadCsvReport: async (payload: any) => {
      try {
        const response = await downloadCsvReport(payload)
        const url = response?.data?.file_url
        window.open(url)
      } catch (error) {
        throw error
      }
    },
    downloadCsvReportAgentAssist: async (payload: any) => {
      try {
        const response = await downloadCsvReportAgentAssist(payload)
        const url = response?.data?.file_url
        window.open(url)
      } catch (error) {
        throw error
      }
    },
    exportAutosolve: async ({ botId, agentName }: { botId: any, agentName: string }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await exportAutosolve(botId)
        dispatch.contentModel.updateContentLoading(false)

        const jsonData = response?.data
        const jsonString = JSON.stringify(jsonData, null, 2)
        const blob = new Blob([jsonString], { type: 'application/json' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url

        const sanitizeFileName = (name: string) => {
          if (!name || typeof name !== 'string') {
            return ''
          }
          return name.replace(/[^a-z0-9]/gi, '_').toLowerCase()
        }
        const now = new Date()
        const dateStr = now.toISOString().split('T')[0] // YYYY-MM-DD
        const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '-') // HH-MM-SS
        const timestamp = `${dateStr}_${timeStr}`
        const sanitizedAgentName = sanitizeFileName(agentName)
        const fileName = sanitizedAgentName
          ? `${sanitizedAgentName}_${timestamp}.json`
          : `autosolve_export_${botId}_${timestamp}.json`

        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Autosolve exported successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        const errorMessage = (error as any)?.response?.data?.detail || 'Failed to export autosolve'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },
    importAutosolve: async ({ payload, flag }: { payload: any, flag: any }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await importAutosolve(payload, flag)
        dispatch.contentModel.updateContentLoading(false)

        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Autosolve imported successfully',
          type: 'success',
        })

        return response?.data
      } catch (error: any) {
        dispatch.contentModel.updateContentLoading(false)

        const errorResponse = error?.response || error?.originalError?.response
        const errorDetail = errorResponse?.data?.detail || errorResponse?.data?.message || error?.message || ''
        const isDraftExistsError = errorDetail.includes('Draft already exists') || errorDetail.includes('overwrite_draft')

        if (!isDraftExistsError) {
          dispatch.commonModel.updateNotificationState({
            message: 'Failed',
            description: errorDetail || 'Failed to import autosolve',
            type: 'failed',
          })
        }

        throw error
      }
    },
    exportWorkflow: async (appId: string) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await exportWorkflow(appId)
        dispatch.contentModel.updateContentLoading(false)

        const jsonData = response?.data
        const downloadUrl =
          (typeof jsonData?.data?.download_url === 'string' && jsonData.data.download_url) ||
          (typeof jsonData?.download_url === 'string' && jsonData.download_url)
        const apiFilename =
          (typeof jsonData?.data?.filename === 'string' && jsonData.data.filename) ||
          (typeof jsonData?.filename === 'string' && jsonData.filename)

        if (!downloadUrl || !apiFilename) {
          throw new Error('Export response did not contain download_url or filename')
        }

        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', apiFilename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        return response
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        const errorMessage = (error as any)?.response?.data?.detail || (error as Error)?.message || 'Failed to export workflow'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },
    importWorkflow: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await importWorkflow(payload)
        dispatch.contentModel.updateContentLoading(false)

        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Workflow imported successfully',
          type: 'success',
        })

        return response?.data
      } catch (error: any) {
        dispatch.contentModel.updateContentLoading(false)

        const errorResponse = error?.response || error?.originalError?.response
        const errorDetail = errorResponse?.data?.detail || errorResponse?.data?.message || error?.message || ''
        const isDraftExistsError = errorDetail.includes('Draft already exists') || errorDetail.includes('overwrite_draft')

        if (!isDraftExistsError) {
          dispatch.commonModel.updateNotificationState({
            message: 'Failed',
            description: errorDetail || 'Failed to import workflow',
            type: 'failed',
          })
        }

        throw error
      }
    },
    getUserMappedRoles: async (role: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        dispatch.contentModel.updateUserMappedRoles('')
        const response = await getUserMappedRoles(role)
        dispatch.contentModel.updateUserMappedRoles(response?.data?.data?.role_count)
        dispatch.contentModel.updateContentLoading(false)

      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)

        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get user roles',
          type: 'failed',
        })
      }
    },

    getcreateScheduler: async (payload: any) => {

      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createScheduler(payload)
        dispatch.contentModel.updatecreateScheduler(response?.data?.data)

        dispatch.contentModel.updateContentLoading(false)

      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To generate code',
          type: 'failed',
        })
      }
    },
    getMasterData: async () => {
      try {
        const response = await getMasterData()
        dispatch.contentModel.updateMasterData(response?.data?.data)
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get master data',
          type: 'failed',
        })
      }
    },

    getBlockLevelHistory: async (instanceId: any) => {
      try {
        //dispatch.contentModel.updateContentLoading(true)

        const response = await getBlockLevelHistory(instanceId)
        dispatch.contentModel.updateBlockLevelHistory(response?.data?.data)

        //dispatch.contentModel.updateContentLoading(false)
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get block level history',
          type: 'failed',
        })
      }
    },

    controlRoomDiscoverScreenSaveFilter: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomDiscoverScreenSaveFilter(payload)
        dispatch.contentModel.updateContentLoading(false)
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To save filter',
          type: 'failed',
        })
      }
    },
    //updateControlRoomDiscoverScreenSavedFilterNames
    getControlRoomDiscoverScreenSavedFilterNames: async (payload: any) => {
      try {

        dispatch.contentModel.updateContentLoading(true);
        const response = await getControlRoomDiscoverScreenSavedFilterNames(payload);
        dispatch.contentModel.updateControlRoomDiscoverScreenSavedFilterNames(response.data.data.items.map((item: any) => item.name));
        dispatch.contentModel.updateContentLoading(false);
        return response;
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false);
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to get control room discover screen saved filter names',
          type: 'failed',
        });
      }
    },
    getControlRoomDiscoverScreenSavedFilterDetails: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getControlRoomDiscoverScreenSavedFilterDetails(payload);
        dispatch.contentModel.updateControlRoomDiscoverScreenSavedFilterDetails(response.data.data);
        dispatch.contentModel.updateContentLoading(false)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get control room discover screen saved filter details',
          type: 'failed',
        })
      }
    },


    getControlRoomDiscoverScreenDelete: async (filterId: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        await deleteFilter(filterId)

        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Filter Deleted successfully.',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Filter Deleting Failed.',
          type: 'error',
        })
      }

    },


    naturalLanguageQueryTranslation: async (payload: any) => {
      try {
        dispatch.contentModel.updatePinotQueryLoading(true)

        const response = await naturalLanguageQueryTranslation(payload)
        dispatch.contentModel.updateNaturalLanguageQueryTranslation(response?.data)

        // Get the SQL query from the first API response
        if (response?.data) {
          // Make the second API call to pinot with the SQL query
          const pinotPayload = {
            query: response.data.sql
          }
          const pinotResponse = await pinotQuery(pinotPayload)

          // Update state with both the SQL query, pinot response, and column_name_mappings
          dispatch.contentModel.updatePinotQueryData({
            response: {
              ...pinotResponse.data,
              column_name_mappings: response.data.column_name_mappings
            },
            query: response.data.sql
          })
        } else {
          throw new Error('Invalid response format')
        }

        dispatch.contentModel.updatePinotQueryLoading(false)

      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get data',
          type: 'failed',
        })
        dispatch.contentModel.updatePinotQueryLoading(false)
      }
    },
    updateCustomField: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true);
        const response = await updateCustomField(payload);

        dispatch.contentModel.updateContentLoading(false);
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Custom field updated successfully',
          type: 'success',
        });

        // Optionally, return the response if needed
        return response;
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false);
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To update custom field',
          type: 'failed',
        });

        // Throw the error to ensure it propagates to the calling function
        throw error;
      }
    },
    validateChannel: async ({ payload, channelType }: any) => {
      try {
        const response = await validateChannel(payload, channelType)
        if (response?.data?.data?.success === true) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Channel validated successfully',
            type: 'success',
          })
        }
        else {
          dispatch.commonModel.updateNotificationState({
            message: 'Failed',
            description: 'Failed To validate channel.Please check the  details provided',
            type: 'failed',
          })
        }
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To validate channel.Please check the  details provided',
          type: 'failed',
        })
      }
    },
    deleteSchedulerEffect: async (schedulerId: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await deleteScheduler(schedulerId)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Scheduler Deleted successfully.',
          type: 'success',
        })
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Error',
          description: 'Scheduler Deleting Failed.',
          type: 'error',
        })
      }
    },
    updateScheduler: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await updateScheduler(payload)
        if (response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Scheduler updated sucessfully',
            type: 'success',
          })
        }

        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update scheduler ',
          type: 'failed',
        })
      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getSchedulerHistory: async ({ schedulerId, payload }: any) => { // Ensure this matches
      try {
        dispatch.contentModel.updateInnerContentLoading(true);
        const response = await getSchedulerHistory(schedulerId, payload);
        const data = response?.data?.data?.results || [];
        dispatch.contentModel.updateSchedulerHistory(data)
      } catch (error) {
      } finally {
        dispatch.contentModel.updateInnerContentLoading(false);
      }
    },
    getAgentDetails: async (agent_id: any) => {
      try {
        const response = await getAgentDetails(agent_id)
        dispatch.contentModel.updateAgent(response?.data?.data)
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get agent details',
          type: 'failed',
        })
      }
    },
    getAutoSolveBlockLevelHistory: async ({ bot_id, conversation_id }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getAutoSolveBlockLevelHistory(bot_id, conversation_id);

        dispatch.contentModel.updateAutoSolveBlockLevelHistory(response?.data?.data);
      } catch (error) {


      }
      dispatch.contentModel.updateContentLoading(false)
    },
    getllmModelDetailsForAutoSolve: async () => {
      try {
        const response = await getllmModelDetailsForAutoSolve()
        dispatch.contentModel.updateLLMModelList(response?.data?.data)
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get llm model details for auto solve',
          type: 'failed',
        })
      }
    },
    fileuploadBulkrun: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true);

        // Show loading notification for bulk upload
        dispatch.commonModel.updateNotificationState({
          message: 'Uploading Bulk Test File...',
          description: 'Please wait while your bulk test file is being uploaded and processed',
          type: 'info',
        });

        const response = await fileuploadBulkrun(payload);
        dispatch.contentModel.updateFileuploadBulkrun(response?.data?.data);

        // Extract file name from FormData for success message
        let fileName = 'bulk test file';
        if (payload instanceof FormData) {
          const dataString = payload.get('data');
          if (dataString && typeof dataString === 'string') {
            const parsedData = JSON.parse(dataString);
            fileName = parsedData.files || 'bulk test file';
          }
        }

        // Dispatch success notification
        dispatch.commonModel.updateNotificationState({
          message: 'Bulk Test File Uploaded',
          description: `${fileName} has been uploaded successfully and is ready for testing`,
          type: 'success',
        });

        dispatch.contentModel.updateContentLoading(false);
      } catch (error: any) {

        // Extract path from FormData
        let path = '';
        if (payload instanceof FormData) {
          const dataString = payload.get('data');
          if (dataString && typeof dataString === 'string') {
            const parsedData = JSON.parse(dataString);
            path = parsedData.path;
          }
        }

        if (path && path.includes('most_likely_questions')) {
          dispatch.commonModel.updateNotificationState({
            message: 'CSV Format Error',
            description: 'CSV must contain columns: "questions" and "score". Please check the template for the correct format.',
            type: 'failed',
          });
        } else if (path && path.includes('bulk_run') || path && path.includes('bulk-test')) {
          dispatch.commonModel.updateNotificationState({
            message: 'CSV Format Error',
            description: 'CSV must contain columns: "input" and "expected_output". Please check the template for the correct format.',
            type: 'failed',
          });
        } else {
          dispatch.commonModel.updateNotificationState({
            message: 'Bulk Test Upload Failed',
            description: 'Failed to upload bulk test file. Please check the file format and try again.',
            type: 'failed',
          });
        }
      }
    },
    autosolverunbatch: async (payload: any) => {
      try {
        dispatch.contentModel.updateTerminateUrlforAutoSolve('')
        dispatch.contentModel.updateAutosolverunbatchLoading(true);

        // Show loading notification for bulk operation
        dispatch.commonModel.updateNotificationState({
          message: 'Processing Bulk Run...',
          description: 'Please wait while your bulk test is being processed',
          type: 'info',
        });

        const response = await autosolverunbatch(payload);

        // Store the terminate URL
        if (response?.data?.terminatePostUri) {
          dispatch.contentModel.updateTerminateUrlforAutoSolve(response.data.terminatePostUri);
        }

        dispatch.contentModel.updateQueryUrl(response?.data);

        const statusResponse = await statusCheckerWithAuth(response?.data?.statusQueryGetUri);

        if (statusResponse.runtimeStatus === "Failed" || statusResponse.runtimeStatus === "Terminated") {
          dispatch.commonModel.updateNotificationState({
            message: 'Bulk Run Failed',
            description: statusResponse.runtimeStatus === "Failed"
              ? 'The bulk run encountered an error and failed to complete'
              : 'The bulk run was terminated',
            type: 'failed',
          });
          // Stop loader on failure/termination
          dispatch.contentModel.updateAutosolverunbatchLoading(false);
        } else {
          const parsedResponse = typeof statusResponse.output === 'string'
            ? JSON.parse(statusResponse.output)
            : statusResponse.output;

          if (parsedResponse) {
            if (parsedResponse?.error) {
              dispatch.commonModel.updateNotificationState({
                message: 'Bulk Run Error',
                description: parsedResponse.error || 'An error occurred during the bulk run',
                type: 'failed',
              });
              // Stop loader on error
              dispatch.contentModel.updateAutosolverunbatchLoading(false);
            } else {
              dispatch.contentModel.updateAutosolverunbatch(parsedResponse);

              // Enhanced success message with results summary
              const totalTests = parsedResponse?.results?.length || 0;
              const passedTests = parsedResponse?.results?.filter((r: any) => r.status === 'passed')?.length || 0;
              const failedTests = totalTests - passedTests;

              dispatch.commonModel.updateNotificationState({
                message: 'Bulk Run Completed',
                description: `Successfully processed ${totalTests} tests. ${passedTests} passed, ${failedTests} failed.`,
                type: 'success',
              });

              // Stop loader on successful completion
              dispatch.contentModel.updateAutosolverunbatchLoading(false);
            }
          }
        }
      } catch (error: any) {
        dispatch.commonModel.updateNotificationState({
          message: 'Bulk Run Failed',
          description: error?.response?.data?.message || 'Failed to start bulk run. Please try again or contact support.',
          type: 'failed',
        });
        // Stop loader on error
        dispatch.contentModel.updateAutosolverunbatchLoading(false);
      }
    },

    controlRoomDynamicQuery: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await controlRoomDynamicQuery(payload)
        dispatch.contentModel.updateContentLoading(false)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get control room dynamic query',
          type: 'failed',
        })
      }
    },

    getControlRoomDiscoverScreenGetColumns: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getControlRoomDiscoverScreenGetColumns()
        dispatch.contentModel.updateContentLoading(false)
        dispatch.contentModel.controlroomFiltersList(response?.data?.data)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get control room discover screen get columns',
          type: 'failed',
        })
      }
    },
    getControlRoomFilterList: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getControlRoomFilterList()
        dispatch.contentModel.updateContentLoading(false)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get control room filter list',
          type: 'failed',
        })
      }
    },
    getOrganizationSummaryDriverFilter: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getOrganizationSummaryDriverFilter()
        dispatch.contentModel.updateOrganizationSummaryDriverFilter(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get organization summary driver filter',
          type: 'failed',
        })
      }
    },

    getControlRoomDiscoverScreenGetColumnValuesForFilter: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getControlRoomDiscoverScreenGetColumnValuesForFilter(payload)
        dispatch.contentModel.updateContentLoading(false)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get control room discover screen get column values for filter',
          type: 'failed',
        })
      }
    },

    supersetCredentials: async () => {
      try {


        const response = await getSupersetCredentials()
        if (response?.status === 200) {

          dispatch.contentModel.updateSupersetAuth(response?.data?.data)
        }
      } catch (err) {
        dispatch.contentModel.updateSupersetAuth(false)

      }
    },
    supersetLogin: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getSupersetLogin(payload.data)
        dispatch.contentModel.updateContentLoading(false)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get control room discover screen get columns',
          type: 'failed',
        })
      }
    },
    supersetCsrfToken: async () => {
      try {

        const response = await getSupersetCsrfToken()
        if (response?.status === 200) {
          dispatch.contentModel.updateSupersetAuth(response?.data?.data)
        }
      } catch (err) {
        dispatch.contentModel.updateSupersetAuth(false)

      }
    },
    getSupersetChartAPI: async (chartId: any, headers: any) => {
      try {
        const response = await getSupersetChartAPI(chartId, headers)
        return response
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get superset chart api',
          type: 'failed',
        })
      }
    },
    getSupersetChartData: async (payload: any) => {
      try {
        const response = await getSupersetChartData(payload)
        return response
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get superset chart data',
          type: 'failed',
        })
      }
    },
    getSupersetChartID: async () => {
      try {

        dispatch.contentModel.updateContentLoading(true)
        const response = await getSupersetChartID()
        //onsole.log("response for superset chartid",response)
        dispatch.contentModel.updateContentLoading(false)
        return response;


      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get superset chart id',
          type: 'failed',
        })
      }
    },
    getSupersetUrl: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getSupersetUrl()
        dispatch.contentModel.updateContentLoading(false)
        return response
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get superset url',
          type: 'failed',
        })
      }
    },
    getRealTimeAudio: async () => {

      try {
        dispatch.contentModel.updateContentLoading(true)

        const response = await getRealTimeAudio()
        dispatch.contentModel.updateRealTimeAudio(response?.data)

        dispatch.contentModel.updateContentLoading(false)
        return response
      }
      catch (error) {
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get realtime audio list',
          type: 'failed',
        })
      }
    },
    getSupersetCustomDashboardList: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getSupersetCustomDashboardList()
        dispatch.contentModel.updateContentLoading(false)
        return response;
      }
      catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To get superset custom dashboard list',
          type: 'failed',
        })
      }
    },
    fetchStatusCountEffect: async (folderId) => {
      try {
        const response = await fetchStatusCount(folderId)
        return response?.data
      } catch (error) {
        throw error
      }
    },
    uploadRetryFilesEffect: async (payload) => {
      try {
        const response = await uploadRetryFiles(payload)
        return response?.data
      } catch (error) {

        throw error
      }
    },
    getAlertsForControlRoom: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getAlertsList(payload)
        dispatch.contentModel.updateAlertsList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to execute query',
          type: 'failed',
        })
      }
    },
    getReportsForControlRoom: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getReportsList(payload)
        dispatch.contentModel.updateReportsList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to execute query',
          type: 'failed',
        })
      }
    },
    addNewReports: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await addNewReports(payload)
        console.log({ response });
        // dispatch.contentModel.updateReportsList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to execute query',
          type: 'failed',
        })
      }
    },
    getColumnValues: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getColumnValues(payload)
        console.log({ response });
        // dispatch.contentModel.updateReportsList(response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to execute query',
          type: 'failed',
        })
      }
    },
    getAlertDetails: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getAlertDetails(payload)
        console.log('Alert details response:', response);
        dispatch.contentModel.updateContentLoading(false)
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch alert details',
          type: 'failed',
        })
        throw error
      }
    },
    createAlert: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await createAlert(payload)
        console.log('Create Alert API response:', response);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Alert created successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to create alert',
          type: 'failed',
        })
        throw error
      }
    },
    updateAlert: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateAlert(payload)
        console.log('Update Alert API response:', response);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Alert updated successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to update alert',
          type: 'failed',
        })
        throw error
      }
    },
    deleteAlert: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await deleteAlert(payload)
        console.log('Delete Alert API response:', response);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Alert deleted successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete alert',
          type: 'failed',
        })
        throw error
      }
    },
    deleteReport: async (report_id: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await deleteReport(report_id)
        console.log('Delete Report API response:', response);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Report deleted successfully',
          type: 'success',
        })
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to delete report',
          type: 'failed',
        })
        throw error
      }
    },
    getTrustforteList: async () => {
      try {
        const response = await getTrustforteList()
        dispatch.contentModel.updateTrustforteList(response.data)
      } catch (error) {

      }
    },
    getLatestPublishedApp: async (appId: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getLatestPublishedApp(appId)
        dispatch.contentModel.updateCurrentPublishedAppDetails(response?.data?.data)
        console.log("response?.data?.data", response?.data?.data)
        dispatch.contentModel.updateContentLoading(false)

      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        throw error
      }
    },

    getTrustforteMailDocumentData: async (id: string) => {
      try {
        const response = await getTrustforteMailDocumentData(id);
        if (response?.data) {
          try {
            // Parse the nested app_output JSON
            const appOutput = JSON.parse(response.data.app_output);
            // Parse the inner content JSON
            const content = JSON.parse(appOutput.content);
            // Store the parsed content directly
            dispatch.contentModel.updateTrustforteMailDocumentData(content);
            return content; // Return the parsed content
          } catch (error) {
            console.error('Error parsing trustforte data:', error);
            dispatch.contentModel.updateTrustforteMailDocumentData(null);
            throw error;
          }
        }
        return null;
      } catch (error) {
        dispatch.contentModel.updateTrustforteMailDocumentData(null);
        throw error;
      }
    },

    getAgentLists: async () => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getAgentsList()
        dispatch.contentModel.getAgentsListsForApp(response?.data?.data)
        console.log('response?.data?.data', response?.data?.data);

        // dispatch.commonModel.updateNotificationState({
        //   message: 'Success',
        //   description: 'Conversation History fetched succesfully',
        //   type: 'success',
        // })
        dispatch.contentModel.updateContentLoading(false)
      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        // dispatch.commonModel.updateNotificationState({
        //   message: 'Failed',
        //   description: 'Failed To list history',
        //   type: 'failed',
        // })
      }
    },
    getDatabaseListEffect: async (payload: { integration_key: string }) => {
      try {
        // dispatch.contentModel.updateContentLoading(true)
        const response = await getDatabaseList(payload)
        dispatch.contentModel.updateDatabaseList(response?.data?.integrations || [])
        // dispatch.contentModel.updateContentLoading(false)
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch database list',
          type: 'failed',
        })
        throw error
      }
    },
    getDatabaseSchemasEffect: async (payload: { integration_key: string; display_name: string }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getDatabaseSchemas(payload)
        dispatch.contentModel.updateDatabaseSchemas(response?.data?.schemas || [])
        dispatch.contentModel.updateContentLoading(false)
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch database schemas',
          type: 'failed',
        })
        throw error
      }
    },
    getDatabaseTablesEffect: async (payload: { integration_key: string; display_name: string; schema: string }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getDatabaseTables(payload)
        dispatch.contentModel.updateDatabaseTables(response?.data?.tables || [])
        dispatch.contentModel.updateContentLoading(false)
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch database tables',
          type: 'failed',
        })
        throw error
      }
    },
    getDatabaseColumnsEffect: async (payload: { integration_key: string; display_name: string; schema: string; table: string }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await getDatabaseColumns(payload)
        dispatch.contentModel.updateDatabaseColumns(response?.data?.columns || [])
        dispatch.contentModel.updateContentLoading(false)
        return response?.data
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed to fetch database columns',
          type: 'failed',
        })
        throw error
      }
    },
    saveIntegrationsEffect: async (payload: {
      integration_key: string;
      status: string;
      ssl: string;
      config_data: Array<{
        key_name: string;
        display_name: string;
        payload_key: string;
        value: string;
      }>;
      integration_display_name: string;
      display_name: string;
    }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await saveIntegrations(payload)
        dispatch.contentModel.updateContentLoading(false)

        // Handle successful response (status 200)
        if (response?.data?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: response?.data?.message || 'Database integration saved successfully',
            type: 'success',
          })
          return response?.data
        }
        // Handle connection test failure (status 508)
        else if (response?.data?.status === 508) {
          dispatch.commonModel.updateNotificationState({
            message: 'Connection Failed',
            description: response?.data?.message || 'Test connection failed',
            type: 'failed',
          })
          throw new Error(response?.data?.message || 'Test connection failed')
        }
        // Handle other error statuses
        else {
          dispatch.commonModel.updateNotificationState({
            message: 'Error',
            description: response?.data?.message || 'Failed to save database integration',
            type: 'failed',
          })
          throw new Error(response?.data?.message || 'Failed to save database integration')
        }
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)

        // Handle network errors or other exceptions
        const errorMessage = (error as any)?.response?.data?.message || (error as any)?.message || 'Failed to save database integration'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },
    updateDatabaseBlockEffect: async (payload: {
      data: {
        label: string;
        config: {
          databse_id: string;
          query: string;
        };
      };
      type: string;
    }) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateDatabaseBlock(payload)
        dispatch.contentModel.updateContentLoading(false)

        // Handle successful response
        if (response?.data?.status === 200 || response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Database block updated successfully',
            type: 'success',
          })
          return response?.data
        } else {
          dispatch.commonModel.updateNotificationState({
            message: 'Error',
            description: response?.data?.message || 'Failed to update database block',
            type: 'failed',
          })
          throw new Error(response?.data?.message || 'Failed to update database block')
        }
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)

        // Handle network errors or other exceptions
        const errorMessage = (error as any)?.response?.data?.message || (error as any)?.message || 'Failed to update database block'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },
    updateScheduleStatusEffect: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await updateScheduleStatus(payload)
        dispatch.contentModel.updateContentLoading(false)

        // Handle successful response
        if (response?.data?.status === 200 || response?.status === 200) {
          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'Schedule status updated successfully',
            type: 'success',
          })
          return response?.data
        } else {
          dispatch.commonModel.updateNotificationState({
            message: 'Error',
            description: response?.data?.message || 'Failed to update schedule status',
            type: 'failed',
          })
          throw new Error(response?.data?.message || 'Failed to update schedule status')
        }
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)

        // Handle network errors or other exceptions
        const errorMessage = (error as any)?.response?.data?.message || (error as any)?.message || 'Failed to update schedule status'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },
    downloadPdfApi: async (payload) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await downloadPdfApi(payload)
        dispatch.contentModel.updateContentLoading(false)

        // Handle successful response
        if (response?.data?.pdf_url) {
          // Create download link from the PDF URL
          const link = document.createElement('a')
          link.href = response.data.pdf_url
          link.download = `${payload.app_name || 'workflow_response'}_${new Date().toISOString().split('T')[0]}.pdf`
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          dispatch.commonModel.updateNotificationState({
            message: 'Success',
            description: 'PDF downloaded successfully',
            type: 'success',
          })
          return response?.data
        } else {
          dispatch.commonModel.updateNotificationState({
            message: 'Error',
            description: response?.data?.message || 'Failed to download PDF',
            type: 'failed',
          })
          throw new Error(response?.data?.message || 'Failed to download PDF')
        }
      } catch (error) {
        console.log('error', error);
        dispatch.contentModel.updateContentLoading(false)

        // Handle network errors or other exceptions
        const errorMessage = (error as any)?.response?.data?.message || (error as any)?.message || 'Failed to download PDF'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },
    getTemplateList: async (payload: any) => {
      try {

        dispatch.contentModel.updateContentLoading(true)
        const response = await getTemplateList(payload)
        //  const response = await getTemplateList('1435d7c8-8890-4712-9d4e-731d6bb898fa')
        const list = response?.data?.templates ?? response?.data?.data ?? []
        dispatch.contentModel.updateTemplateList(list)
        console.log("template list", list)
        dispatch.contentModel.updateContentLoading(false)

      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        throw error
      }
    },
    fetchTemplateDetails: async (payload: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await fetchTemplateDetails(payload)
        dispatch.contentModel.updateTemplateDetails(response?.data)
        dispatch.contentModel.updateContentLoading(false)
      } catch (error: any) {
        dispatch.contentModel.updateContentLoading(false)
        const errorMessage = error?.response?.detail || 'Failed to fetch template details. Please try again.'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed to Load Template',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },

    uploadTemplate: async (payload) => {
      try {
        dispatch.contentModel.updatefileLoading(true)

        const response = await uploadTemplate(payload)

        dispatch.contentModel.updateFileParams(response?.data?.data)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'File Upload Successful',
          type: 'success',
        })

        // Refresh template list for the same app after successful upload
        let idFromPayload: any = null
        let initiatedBy: any = 'aiWorkFlow'

        // Support FormData payload (extract 'data' JSON) and plain object payloads
        try {
          const maybeGet = (payload as any) && typeof (payload as any).get === 'function' ? (payload as any).get : null
          if (maybeGet) {
            const dataField = maybeGet.call(payload, 'data')
            if (dataField) {
              const parsed = typeof dataField === 'string' ? JSON.parse(dataField) : JSON.parse(String(dataField))
              idFromPayload = parsed?.id ?? null
              initiatedBy = parsed?.initiated_by || initiatedBy
            }
          } else {
            idFromPayload = (payload as any)?.data?.id || (payload as any)?.id || null
            initiatedBy = (payload as any)?.data?.initiated_by || (payload as any)?.initiated_by || initiatedBy
          }
        } catch (_) {
          // ignore parse errors; fall back to defaults
        }

        if (idFromPayload) {
          const templateListPayload: any = {
            id: idFromPayload,
            initiated_by: initiatedBy,
          }
          try {
            await (dispatch as any).contentModel.getTemplateList(templateListPayload)
          } catch (error: any) {
            dispatch.commonModel.updateNotificationState({
              message: 'Failed',
              description: 'Failed to upload template',
              type: 'failed',
            })
            throw error
          } finally {
            dispatch.contentModel.updatefileLoading(false)
          }
        } else {
          dispatch.contentModel.updatefileLoading(false)
        }
      } catch (error: any) {
        dispatch.contentModel.updatefileLoading(false)
        const errorMessage = error?.response?.data?.detail || error?.response?.data?.message || error?.message || 'Failed to upload template. Please try again.'
        dispatch.commonModel.updateNotificationState({
          message: 'Failed to Upload Template',
          description: errorMessage,
          type: 'failed',
        })
        throw error
      }
    },

    deleteTemplate: async ({ folderId, initiated_by, id }: any) => {
      try {
        dispatch.contentModel.updateContentLoading(true)
        const response = await deleteTemplate(folderId, initiated_by, id)
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Success',
          description: 'Deleted Template succcessfuly',
          type: 'success',
        })

      } catch (error) {
        dispatch.contentModel.updateContentLoading(false)
        dispatch.commonModel.updateNotificationState({
          message: 'Failed',
          description: 'Failed To Delete Template',
          type: 'failed',
        })
      }
    },

  }),
})


